/* Source: /home/sidsolaiyappan/skooch_ai/scheduler/scheduler_view.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { SchedulerWeekNav } from "./scheduler_calendar.js";
import { MobileDayView } from "./mobile_day_view.js";
import { MobileViewSwitcher } from "./mobile_view_switcher.js";
import { MobileMonthView } from "./mobile_month_view.js";
import { MobileWeekAgenda } from "./mobile_week_agenda.js";
import { MobileUnscheduled } from "./mobile_unscheduled.js";
import { dedupeFixedBlocks } from "../shared/fixed_event_helpers.js";
import { groupPlacementReasons, computeStalePlacements } from "../shared/scheduler_helpers.js";
import { replanStalePlacements } from "./scheduler_optimize.js";
import { dropYToSlotMins, classifyDropOutcome } from "../shared/scheduler_math.js";
import { computeMovePlacement } from "../shared/task_handlers.js";
import { onSyncNowGcal } from "../shared/gcal_connect.js";
import { formatSyncAgo, gcalSyncLabelState } from "../shared/sync_format.js";
import { useStoreSlice, getStoreGcalStatus, subscribeStoreGcalStatus, getStoreGcalSyncing, subscribeStoreGcalSyncing, getStoreGcalClock, subscribeStoreGcalClock, setStoreGcalClock, getStoreTasks, setStoreSchLog, getStoreSchedule, subscribeStoreSchedule, getStoreFixedBlocks, subscribeStoreFixedBlocks, getStoreEnergyData, subscribeStoreEnergyData, getStoreSchDirty, subscribeStoreSchDirty, getStoreSchOptimized, subscribeStoreSchOptimized, getStoreSchLog, subscribeStoreSchLog, getStoreOverflow, subscribeStoreOverflow, getStoreSuggestions, subscribeStoreSuggestions, getStoreSchConstraints, subscribeStoreSchConstraints, getStoreSchOverflowExpandedIds, subscribeStoreSchOverflowExpandedIds, getStoreSchPopupOpen, subscribeStoreSchPopupOpen, getStoreSchPopupBlock, subscribeStoreSchPopupBlock, getStoreSchReasoningTarget, subscribeStoreSchReasoningTarget, getStoreIsAdmin, subscribeStoreIsAdmin, getStoreSchDevScenarioActive, subscribeStoreSchDevScenarioActive, getStoreCoachMarkStep, subscribeStoreCoachMarkStep, getStoreDevSyncScheduleAfterOptimize, subscribeStoreDevSyncScheduleAfterOptimize, getStoreSchPrefPeak, subscribeStoreSchPrefPeak, getStoreSchPrefBlock, subscribeStoreSchPrefBlock, getStoreSchPrefBuf, subscribeStoreSchPrefBuf, getStoreSchPrefStrat, subscribeStoreSchPrefStrat, getStoreSchPrefAfter, subscribeStoreSchPrefAfter, getStoreSelectedDay, subscribeStoreSelectedDay, getStoreIsMobileViewport, subscribeStoreIsMobileViewport, getStoreMobileSchedView, subscribeStoreMobileSchedView, setStoreMobileSchedView, getStoreMobileSandboxToast, subscribeStoreMobileSandboxToast, setStoreMobileSandboxToast } from "../shared/store.js";
import { getStoreSchTaskName, subscribeStoreSchTaskName, getStoreSchTaskCat, subscribeStoreSchTaskCat, getStoreSchTaskDur, subscribeStoreSchTaskDur, getStoreSchTaskDurH, subscribeStoreSchTaskDurH, getStoreSchTaskDurM, subscribeStoreSchTaskDurM, getStoreSchTaskPri, subscribeStoreSchTaskPri, getStoreSchTaskDL, subscribeStoreSchTaskDL, getStoreSchTaskIsRecurring, subscribeStoreSchTaskIsRecurring, getStoreSchTaskRecurrenceInterval, subscribeStoreSchTaskRecurrenceInterval, getStoreSchTaskRecurrenceUnit, subscribeStoreSchTaskRecurrenceUnit, getStoreSchTaskRecurrenceWeekday, subscribeStoreSchTaskRecurrenceWeekday, getStoreSchEvName, subscribeStoreSchEvName, getStoreSchEvCat, subscribeStoreSchEvCat, getStoreSchEvStart, subscribeStoreSchEvStart, getStoreSchEvEnd, subscribeStoreSchEvEnd, getStoreSchEvIsRecurring, subscribeStoreSchEvIsRecurring, getStoreSchEvIsAllDay, subscribeStoreSchEvIsAllDay, getStoreSchEvRecurrenceInterval, subscribeStoreSchEvRecurrenceInterval, getStoreSchEvRecurrenceUnit, subscribeStoreSchEvRecurrenceUnit, getStoreSchEvDate, subscribeStoreSchEvDate, getStoreSchEvMon, subscribeStoreSchEvMon, getStoreSchEvTue, subscribeStoreSchEvTue, getStoreSchEvWed, subscribeStoreSchEvWed, getStoreSchEvThu, subscribeStoreSchEvThu, getStoreSchEvFri, subscribeStoreSchEvFri, getStoreSchEvSat, subscribeStoreSchEvSat, getStoreSchEvSun, subscribeStoreSchEvSun, getStoreSchConType, subscribeStoreSchConType, getStoreSchConStart, subscribeStoreSchConStart, getStoreSchConEnd, subscribeStoreSchConEnd, getStoreSchConCat, subscribeStoreSchConCat, getStoreSchConMax, subscribeStoreSchConMax, getStoreSchConMon, subscribeStoreSchConMon, getStoreSchConTue, subscribeStoreSchConTue, getStoreSchConWed, subscribeStoreSchConWed, getStoreSchConThu, subscribeStoreSchConThu, getStoreSchConFri, subscribeStoreSchConFri, getStoreSchConSat, subscribeStoreSchConSat, getStoreSchConSun, subscribeStoreSchConSun } from "../shared/store.js";
import { getStoreSchEditTitle, subscribeStoreSchEditTitle, getStoreSchEditPri, subscribeStoreSchEditPri, getStoreSchEditDL, subscribeStoreSchEditDL, getStoreSchEditDur, subscribeStoreSchEditDur, getStoreSchEditCat, subscribeStoreSchEditCat, getStoreSchEditLoc, subscribeStoreSchEditLoc, getStoreSchEditStart, subscribeStoreSchEditStart, getStoreSchEditEnd, subscribeStoreSchEditEnd, getStoreSchEditDay, subscribeStoreSchEditDay, getStoreSchEditDays, subscribeStoreSchEditDays, getStoreSchEditDate, subscribeStoreSchEditDate, getStoreSchEvLoc, subscribeStoreSchEvLoc, getStoreSchPopupDirty, subscribeStoreSchPopupDirty, getStoreSchPopupSaveState, subscribeStoreSchPopupSaveState, getStoreSchZoom, subscribeStoreSchZoom, getStoreSchReportOpen, subscribeStoreSchReportOpen, getStoreDevMode, subscribeStoreDevMode, getStoreSchSidebarMode, subscribeStoreSchSidebarMode, getStoreSchFormError, subscribeStoreSchFormError } from "../shared/store.js";
const _jac = {
  int: {
    bit_length(n) {
      if (n === 0) return 0;
      return Math.floor(Math.log2(Math.abs(n))) + 1;
    },
    bit_count(n) {
      let x = Math.abs(n);
      let count = 0;
      while (x) { count += x & 1; x >>= 1; }
      return count;
    },
    to_bytes(n, length, byteorder) {
      const bytes = [];
      let val = n < 0 ? (1 << (length * 8)) + n : n;
      for (let i = 0; i < length; i++) {
        bytes.push(val & 0xff);
        val >>= 8;
      }
      if (byteorder === "big") bytes.reverse();
      return bytes;
    },
    from_bytes(bytes, byteorder) {
      const b = byteorder === "big" ? bytes : [...bytes].reverse();
      let result = 0;
      for (const byte of b) result = (result << 8) | byte;
      return result;
    },
    mod(a, b) { return ((a % b) + b) % b; }
  },

  float: {
    as_integer_ratio(f) {
      if (!isFinite(f)) throw new _jac.exc.ValueError("cannot convert " + f + " to integer ratio");
      if (f === 0) return [0, 1];
      let num = f, den = 1;
      while (num !== Math.floor(num)) { num *= 2; den *= 2; }
      const g = _jac.float._gcd(Math.abs(num), den);
      return [num / g, den / g];
    },
    _gcd(a, b) { while (b) { [a, b] = [b, a % b]; } return a; },
    hex(f) {
      return f.toString(16);
    },
    fromhex(s) {
      return parseFloat(s);
    },
    mod(a, b) { return ((a % b) + b) % b; }
  },

  complex: {
    conjugate(c) { return {re: c.re, im: -c.im}; },
    add(a, b) { return {re: a.re + b.re, im: a.im + b.im}; },
    sub(a, b) { return {re: a.re - b.re, im: a.im - b.im}; },
    mul(a, b) { return {re: a.re * b.re - a.im * b.im, im: a.re * b.im + a.im * b.re}; },
    truediv(a, b) {
      const d = b.re * b.re + b.im * b.im;
      return {re: (a.re * b.re + a.im * b.im) / d, im: (a.im * b.re - a.re * b.im) / d};
    },
    pow(a, b) {
      if (typeof b === "number") b = {re: b, im: 0};
      if (typeof a === "number") a = {re: a, im: 0};
      if (b.im === 0 && Number.isInteger(b.re)) {
        let result = {re: 1, im: 0};
        for (let i = 0; i < Math.abs(b.re); i++) result = _jac.complex.mul(result, a);
        return b.re < 0 ? _jac.complex.truediv({re: 1, im: 0}, result) : result;
      }
      const r = Math.sqrt(a.re * a.re + a.im * a.im);
      const theta = Math.atan2(a.im, a.re);
      const lnr = Math.log(r);
      const newR = Math.exp(lnr * b.re - theta * b.im);
      const newTheta = lnr * b.im + theta * b.re;
      return {re: newR * Math.cos(newTheta), im: newR * Math.sin(newTheta)};
    },
    eq(a, b) {
      if (typeof b === "number") b = {re: b, im: 0};
      if (typeof a === "number") a = {re: a, im: 0};
      return a.re === b.re && a.im === b.im;
    },
    neg(a) { return {re: -a.re, im: -a.im}; },
    pos(a) { return {re: +a.re, im: +a.im}; }
  },

  str: {
    capitalize(s) {
      if (s.length === 0) return s;
      return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    },
    title(s) {
      return s.replace(/\b\w/g, c => c.toUpperCase());
    },
    swapcase(s) {
      return [...s].map(c => c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase()).join("");
    },
    count(s, sub, start, end) {
      const t = s.slice(start || 0, end);
      if (sub === "") return t.length + 1;
      let count = 0, pos = 0;
      while ((pos = t.indexOf(sub, pos)) !== -1) { count++; pos += sub.length; }
      return count;
    },
    find(s, sub, start, end) {
      const t = s.slice(start || 0, end);
      const idx = t.indexOf(sub);
      return idx === -1 ? -1 : idx + (start || 0);
    },
    rfind(s, sub, start, end) {
      const t = s.slice(start || 0, end);
      const idx = t.lastIndexOf(sub);
      return idx === -1 ? -1 : idx + (start || 0);
    },
    index(s, sub, start, end) {
      const idx = _jac.str.find(s, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    rindex(s, sub, start, end) {
      const idx = _jac.str.rfind(s, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    startswith(s, prefix, start, end) {
      return s.slice(start || 0, end).startsWith(prefix);
    },
    endswith(s, suffix, start, end) {
      return s.slice(start || 0, end).endsWith(suffix);
    },
    replace(s, old, new_, count) {
      if (count === undefined) return s.split(old).join(new_);
      let result = s, n = 0;
      while (n < count) {
        const idx = result.indexOf(old);
        if (idx === -1) break;
        result = result.slice(0, idx) + new_ + result.slice(idx + old.length);
        n++;
      }
      return result;
    },
    strip(s, chars) {
      if (!chars) return s.trim();
      let start = 0, end = s.length;
      while (start < end && chars.indexOf(s[start]) !== -1) start++;
      while (end > start && chars.indexOf(s[end - 1]) !== -1) end--;
      return s.slice(start, end);
    },
    lstrip(s, chars) {
      if (!chars) return s.trimStart();
      let start = 0;
      while (start < s.length && chars.indexOf(s[start]) !== -1) start++;
      return s.slice(start);
    },
    rstrip(s, chars) {
      if (!chars) return s.trimEnd();
      let end = s.length;
      while (end > 0 && chars.indexOf(s[end - 1]) !== -1) end--;
      return s.slice(0, end);
    },
    removeprefix(s, prefix) {
      return s.startsWith(prefix) ? s.slice(prefix.length) : s;
    },
    removesuffix(s, suffix) {
      return (suffix && s.endsWith(suffix)) ? s.slice(0, -suffix.length) : s;
    },
    split(s, sep, maxsplit) {
      if (sep === undefined || sep === null) {
        const parts = s.trim().split(/\s+/);
        if (maxsplit === undefined) return parts;
        if (maxsplit <= 0) return [s];
        return [...parts.slice(0, maxsplit), parts.slice(maxsplit).join(" ")].filter(x => x !== undefined);
      }
      if (maxsplit === undefined) return s.split(sep);
      const parts = s.split(sep);
      if (parts.length <= maxsplit + 1) return parts;
      return [...parts.slice(0, maxsplit), parts.slice(maxsplit).join(sep)];
    },
    rsplit(s, sep, maxsplit) {
      if (maxsplit === undefined) return _jac.str.split(s, sep);
      const parts = s.split(sep);
      if (parts.length <= maxsplit + 1) return parts;
      const keep = parts.length - maxsplit;
      return [parts.slice(0, keep).join(sep), ...parts.slice(keep)];
    },
    splitlines(s, keepends) {
      const lines = s.split(/(\r\n|\r|\n)/);
      const result = [];
      for (let i = 0; i < lines.length; i += 2) {
        const line = lines[i];
        const sep = lines[i + 1] || "";
        if (line || sep) result.push(keepends ? line + sep : line);
      }
      return result;
    },
    partition(s, sep) {
      const idx = s.indexOf(sep);
      if (idx === -1) return [s, "", ""];
      return [s.slice(0, idx), sep, s.slice(idx + sep.length)];
    },
    rpartition(s, sep) {
      const idx = s.lastIndexOf(sep);
      if (idx === -1) return ["", "", s];
      return [s.slice(0, idx), sep, s.slice(idx + sep.length)];
    },
    format(s, ...args) {
      let i = 0;
      return s.replace(/\{(\w*)\}/g, (match, key) => {
        if (key === "") return args[i++];
        if (!isNaN(key)) return args[parseInt(key)];
        return args[0] && typeof args[0] === "object" ? args[0][key] : match;
      });
    },
    format_map(s, mapping) {
      return s.replace(/\{(\w+)\}/g, (match, key) => key in mapping ? mapping[key] : match);
    },
    center(s, width, fillchar) {
      const fc = fillchar || " ";
      if (s.length >= width) return s;
      const total = width - s.length;
      const left = Math.floor(total / 2);
      return fc.repeat(left) + s + fc.repeat(total - left);
    },
    zfill(s, width) {
      if (s.length >= width) return s;
      const sign = (s[0] === "+" || s[0] === "-") ? s[0] : "";
      const body = sign ? s.slice(1) : s;
      return sign + "0".repeat(width - s.length) + body;
    },
    expandtabs(s, tabsize) {
      const ts = tabsize === undefined ? 8 : tabsize;
      let result = "", col = 0;
      for (const c of s) {
        if (c === "\t") { const sp = ts - (col % ts); result += " ".repeat(sp); col += sp; }
        else if (c === "\n" || c === "\r") { result += c; col = 0; }
        else { result += c; col++; }
      }
      return result;
    },
    isnumeric(s) {
      if (s.length === 0) return false;
      return [...s].every(c => /[\d\u00B2\u00B3\u00B9\u00BC-\u00BE\u2150-\u218F]/.test(c));
    },
    istitle(s) {
      return s === _jac.str.title(s) && /[A-Za-z]/.test(s);
    },
    translate(s, table) {
      return [...s].map(c => {
        const code = c.charCodeAt(0);
        if (code in table) {
          const v = table[code];
          if (v === null) return "";
          if (typeof v === "number") return String.fromCharCode(v);
          return v;
        }
        return c;
      }).join("");
    },
    maketrans(...args) {
      const table = {};
      if (args.length === 1) {
        const mapping = args[0];
        for (const [k, v] of Object.entries(mapping)) {
          table[typeof k === "string" ? k.charCodeAt(0) : k] = v;
        }
      } else if (args.length >= 2) {
        const from_ = args[0], to_ = args[1];
        for (let i = 0; i < from_.length; i++) {
          table[from_.charCodeAt(i)] = to_.charCodeAt(i);
        }
        if (args[2]) {
          for (const c of args[2]) table[c.charCodeAt(0)] = null;
        }
      }
      return table;
    },
    mod(s, args) {
      let i = 0;
      const a = Array.isArray(args) ? args : [args];
      return s.replace(/%([sd%])/g, (m, fmt) => {
        if (fmt === "%") return "%";
        return String(a[i++]);
      });
    }
  },

  // Runtime-polymorphic method dispatch, used when the codegen cannot prove
  // the static type of a method-call receiver (e.g. a `dict`-typed prop, the
  // result of `or` widening, or a comprehension over an untyped value) and so
  // cannot pick a typed emitter. The compiler emits
  // `_jac.poly.call(obj, "name", ...args)`; `call` resolves the *runtime* type
  // of `obj` and applies the matching Python operation, forwards to a
  // same-named method on a user-defined object, or raises AttributeError. The
  // per-type tables below carry the trivial native-mapped methods inline and
  // delegate the non-trivial ones to the shared `_jac.str/list/dict/set`
  // helpers, so each operation has a single implementation and no Python
  // method name can leak verbatim into the emitted JavaScript.
  poly: {
    _typename(o) {
      if (o === null || o === undefined) return "NoneType";
      if (Array.isArray(o)) return "list";
      if (o instanceof Set) return "set";
      if (o instanceof Map) return "dict";
      if (o instanceof Uint8Array) return "bytes";
      const t = typeof o;
      if (t === "string") return "str";
      if (t === "boolean") return "bool";
      if (t === "number") return Number.isInteger(o) ? "int" : "float";
      if (t === "object") return (o.constructor && o.constructor.name) || "object";
      return t;
    },
    // --- per-runtime-type Python method tables (keyed by Python name) ---
    // Trivial native-mapped ops are inline; non-trivial ones delegate to the
    // shared `_jac.<type>` helpers (which the typed emitters also use), so the
    // typed and polymorphic paths share one implementation.
    _str: {
      lower: (s) => s.toLowerCase(),
      upper: (s) => s.toUpperCase(),
      casefold: (s) => s.toLowerCase(),
      strip: (s, chars) => {
        if (chars === undefined) return s.trim();
        let i = 0, j = s.length;
        while (i < j && chars.indexOf(s[i]) !== -1) i++;
        while (j > i && chars.indexOf(s[j - 1]) !== -1) j--;
        return s.slice(i, j);
      },
      lstrip: (s, chars) => {
        if (chars === undefined) return s.replace(/^\s+/, "");
        let i = 0;
        while (i < s.length && chars.indexOf(s[i]) !== -1) i++;
        return s.slice(i);
      },
      rstrip: (s, chars) => {
        if (chars === undefined) return s.replace(/\s+$/, "");
        let j = s.length;
        while (j > 0 && chars.indexOf(s[j - 1]) !== -1) j--;
        return s.slice(0, j);
      }
    },
    _list: {
      append: (a, x) => { a.push(x); return null; },
      clear: (a) => { a.length = 0; return null; },
      copy: (a) => a.slice(),
      count: (a, x) => _jac.list.count(a, x),
      extend: (a, b) => { for (const v of b) a.push(v); return null; },
      index: (a, x, start, end) => _jac.list.index(a, x, start, end),
      insert: (a, i, x) => { a.splice(i, 0, x); return null; },
      pop: (a, i) => {
        if (i === undefined) return a.pop();
        const idx = i < 0 ? a.length + i : i;
        return a.splice(idx, 1)[0];
      },
      remove: (a, x) => _jac.list.remove(a, x),
      reverse: (a) => { a.reverse(); return null; },
      sort: (a, key) => _jac.list.sort(a, key)
    },
    _dict: {
      clear: (o) => _jac.dict.clear(o),
      copy: (o) => ({ ...o }),
      // Python `dict.get`: returns the stored value when the key is present
      // (even if it is null), and the default only when the key is absent.
      // A membership check is required — `o[key] ?? default_` would wrongly
      // substitute the default for a present-but-null value.
      get: (o, key, default_) =>
        Object.prototype.hasOwnProperty.call(o, key) ? o[key] : default_,
      items: (o) => Object.entries(o),
      keys: (o) => Object.keys(o),
      pop: (o, key, default_) => _jac.dict.pop(o, key, default_),
      popitem: (o) => _jac.dict.popitem(o),
      setdefault: (o, key, default_) => _jac.dict.setdefault(o, key, default_),
      update: (o, other) => {
        if (other instanceof Map) { for (const [k, v] of other) o[k] = v; }
        else if (Array.isArray(other)) { for (const [k, v] of other) o[k] = v; }
        else if (other) { for (const k of Object.keys(other)) o[k] = other[k]; }
        return null;
      },
      values: (o) => Object.values(o)
    },
    _set: {
      add: (s, x) => { s.add(x); return null; },
      clear: (s) => { s.clear(); return null; },
      copy: (s) => new Set(s),
      difference: (a, b) => _jac.set.difference(a, b),
      difference_update: (s, o) => _jac.set.difference_update(s, o),
      discard: (s, x) => { s.delete(x); return null; },
      intersection: (a, b) => _jac.set.intersection(a, b),
      intersection_update: (s, o) => _jac.set.intersection_update(s, o),
      isdisjoint: (a, b) => _jac.set.isDisjointFrom(a, b instanceof Set ? b : new Set(b)),
      issubset: (a, b) => _jac.set.isSubsetOf(a, b instanceof Set ? b : new Set(b)),
      issuperset: (a, b) => _jac.set.isSupersetOf(a, b instanceof Set ? b : new Set(b)),
      pop: (s) => _jac.set.pop(s),
      remove: (s, x) => _jac.set.remove(s, x),
      symmetric_difference: (a, b) => _jac.set.symmetricDifference(a, b),
      symmetric_difference_update: (s, o) => _jac.set.symmetric_difference_update(s, o),
      union: (a, b) => _jac.set.union(a, b),
      update: (s, o) => _jac.set.update(s, o)
    },
    // Jac dicts compile to plain objects, but interop code may hand us a real
    // Map; mirror the dict methods over the Map API for that case.
    _map: {
      clear: (m) => { m.clear(); return null; },
      copy: (m) => new Map(m),
      get: (m, key, default_) => (m.has(key) ? m.get(key) : default_),
      items: (m) => [...m.entries()],
      keys: (m) => [...m.keys()],
      pop: (m, key, default_) => {
        if (m.has(key)) { const v = m.get(key); m.delete(key); return v; }
        if (default_ !== undefined) return default_;
        throw new _jac.exc.KeyError("KeyError: " + key);
      },
      popitem: (m) => {
        if (m.size === 0) throw new _jac.exc.KeyError("dictionary is empty");
        const key = [...m.keys()].pop();
        const val = m.get(key);
        m.delete(key);
        return [key, val];
      },
      setdefault: (m, key, default_) => {
        if (!m.has(key)) m.set(key, default_ === undefined ? null : default_);
        return m.get(key);
      },
      update: (m, other) => {
        if (other instanceof Map) { for (const [k, v] of other) m.set(k, v); }
        else if (Array.isArray(other)) { for (const [k, v] of other) m.set(k, v); }
        else if (other) { for (const k of Object.keys(other)) m.set(k, other[k]); }
        return null;
      },
      values: (m) => [...m.values()]
    },
    // Single entry point. `obj.method(...args)` on a receiver whose static
    // type is not provably primitive is compiled to
    // `_jac.poly.call(obj, "method", ...args)`.
    call(o, m, ...args) {
      // 1. Genuine JS primitives get Python-semantic dispatch: a plain object
      //    is a Python dict, an Array is a list, a Set/Map/string/number/bytes
      //    maps to its Python counterpart. These are the types whose Python
      //    method semantics differ from (or have no) native JS equivalent.
      if (typeof o === "string") {
        if (_jac.poly._str[m]) return _jac.poly._str[m](o, ...args);
        if (_jac.str[m]) return _jac.str[m](o, ...args);
      } else if (typeof o === "number") {
        const ns = Number.isInteger(o) ? _jac.int : _jac.float;
        if (ns && ns[m]) return ns[m](o, ...args);
      } else if (Array.isArray(o)) {
        if (_jac.poly._list[m]) return _jac.poly._list[m](o, ...args);
      } else if (o instanceof Set) {
        if (_jac.poly._set[m]) return _jac.poly._set[m](o, ...args);
      } else if (o instanceof Map) {
        if (_jac.poly._map[m]) return _jac.poly._map[m](o, ...args);
      } else if (o instanceof Uint8Array) {
        if (_jac.bytes[m]) return _jac.bytes[m](o, ...args);
      } else if (
        o !== null && o !== undefined && typeof o === "object"
        && (Object.getPrototypeOf(o) === Object.prototype
            || Object.getPrototypeOf(o) === null)
      ) {
        // A plain object is a Python dict literal.
        if (_jac.poly._dict[m]) return _jac.poly._dict[m](o, ...args);
      }
      // 2. Otherwise forward to a same-named method the receiver carries
      //    itself: a user-defined class instance, a host/framework object
      //    (Headers, URLSearchParams, ...), a callable with attached methods,
      //    or a Set/Map/Array method not mirrored above. This matches the
      //    direct `obj.method(...)` that a typed call would have emitted.
      if (o !== null && o !== undefined && typeof o[m] === "function") {
        return o[m](...args);
      }
      // 3. Nothing applies: raise the Python-style error instead of leaking a
      //    method name or silently returning a wrong value.
      throw new _jac.exc.AttributeError(
        "'" + _jac.poly._typename(o) + "' object has no attribute '" + m + "'");
    },
    // Backward-compatible named shims. The compiler now emits `call`, but a
    // previously-built bundle may still reference a named helper; these route
    // it through the same dispatcher (rest params preserve the arg count).
    lower(s, ...r) { return _jac.poly.call(s, "lower", ...r); },
    upper(s, ...r) { return _jac.poly.call(s, "upper", ...r); },
    strip(s, ...r) { return _jac.poly.call(s, "strip", ...r); },
    lstrip(s, ...r) { return _jac.poly.call(s, "lstrip", ...r); },
    rstrip(s, ...r) { return _jac.poly.call(s, "rstrip", ...r); },
    append(a, ...r) { return _jac.poly.call(a, "append", ...r); },
    extend(a, ...r) { return _jac.poly.call(a, "extend", ...r); },
    pop(a, ...r) { return _jac.poly.call(a, "pop", ...r); },
    get(o, ...r) { return _jac.poly.call(o, "get", ...r); },
    contains(c, x) {
      // Python-equivalent membership for a value of unknown static type.
      // string -> substring; array (list/tuple/range) -> element;
      // Set/Map -> key/element; plain object (dict) -> own key.
      if (typeof c === "string") return c.includes(x);
      if (Array.isArray(c)) return c.includes(x);
      if (c instanceof Set || c instanceof Map) return c.has(x);
      if (c !== null && typeof c === "object") {
        return Object.prototype.hasOwnProperty.call(c, x);
      }
      return false;
    },
    getitem(c, i) {
      // Subscript read for a value of unknown static type. This is a faithful
      // superset of a raw `c[i]`: it only adds Python's negative indexing for
      // sequences (string/array) and otherwise preserves JS semantics exactly
      // (mapping/object access, out-of-range -> `undefined`, no new throws).
      if (typeof i === "number" && i < 0
          && (typeof c === "string" || Array.isArray(c))) {
        return c[c.length + i];
      }
      if (c instanceof Map) return c.get(i);
      return c[i];
    },
    setitem(c, i, v) {
      // Subscript assignment for a value of unknown/list static type. A
      // negative index writes the array element counted from the end (a raw
      // JS `c[-1] = v` would instead create a bogus "-1" property); every
      // other case behaves like a plain `c[i] = v`.
      if (typeof i === "number" && i < 0 && Array.isArray(c)) {
        c[c.length + i] = v;
        return v;
      }
      if (c instanceof Map) { c.set(i, v); return v; }
      c[i] = v;
      return v;
    },
    and_(a, bf) {
      // Python `a and b`: returns `a` when it is falsy, else evaluates and
      // returns `b`. `bf` is a thunk so the right operand keeps short-circuit
      // (lazy) evaluation, and `a` is evaluated exactly once by the caller.
      return _jac.builtin.bool(a) ? bf() : a;
    },
    or_(a, bf) {
      // Python `a or b`: returns `a` when it is truthy, else `b`.
      return _jac.builtin.bool(a) ? a : bf();
    }
  },

  list: {
    remove(arr, val) {
      const i = arr.indexOf(val);
      if (i === -1) throw new _jac.exc.ValueError("list.remove(x): x not in list");
      arr.splice(i, 1);
    },
    index(arr, val, start, end) {
      const s = start || 0;
      const e = end === undefined ? arr.length : end;
      for (let i = s; i < e; i++) {
        if (arr[i] === val) return i;
      }
      throw new _jac.exc.ValueError(val + " is not in list");
    },
    count(arr, val) {
      let c = 0;
      for (const item of arr) { if (item === val) c++; }
      return c;
    },
    sort(arr, key) {
      if (key) {
        arr.sort((a, b) => {
          const ka = key(a), kb = key(b);
          return ka < kb ? -1 : ka > kb ? 1 : 0;
        });
      } else {
        arr.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
      }
    },
    repeat(arr, n) {
      const result = [];
      for (let i = 0; i < n; i++) result.push(...arr);
      return result;
    },
    eq(a, b) { return JSON.stringify(a) === JSON.stringify(b); },
    lt(a, b) {
      for (let i = 0; i < Math.min(a.length, b.length); i++) {
        if (a[i] < b[i]) return true;
        if (a[i] > b[i]) return false;
      }
      return a.length < b.length;
    },
    gt(a, b) { return _jac.list.lt(b, a); },
    le(a, b) { return _jac.list.eq(a, b) || _jac.list.lt(a, b); },
    ge(a, b) { return _jac.list.eq(a, b) || _jac.list.gt(a, b); },
    imul(arr, n) {
      const orig = [...arr];
      arr.length = 0;
      for (let i = 0; i < n; i++) arr.push(...orig);
      return arr;
    }
  },

  dict: {
    pop(d, key, default_) {
      if (key in d) { const v = d[key]; delete d[key]; return v; }
      if (default_ !== undefined) return default_;
      throw new _jac.exc.KeyError("KeyError: " + key);
    },
    popitem(d) {
      const keys = Object.keys(d);
      if (keys.length === 0) throw new _jac.exc.KeyError("dictionary is empty");
      const key = keys[keys.length - 1];
      const val = d[key];
      delete d[key];
      return [key, val];
    },
    setdefault(d, key, default_) {
      if (!(key in d)) d[key] = default_ === undefined ? null : default_;
      return d[key];
    },
    clear(d) {
      for (const key of Object.keys(d)) delete d[key];
    },
    fromkeys(keys, value) {
      const d = {};
      const v = value === undefined ? null : value;
      for (const k of keys) d[k] = v;
      return d;
    },
    eq(a, b) {
      const ka = Object.keys(a), kb = Object.keys(b);
      if (ka.length !== kb.length) return false;
      for (const k of ka) {
        if (!(k in b)) return false;
        const va = a[k], vb = b[k];
        if (va !== vb) {
          if (typeof va === "object" && typeof vb === "object" && va !== null && vb !== null) {
            if (JSON.stringify(va) !== JSON.stringify(vb)) return false;
          } else return false;
        }
      }
      return true;
    }
  },

  set: {
    remove(s, val) {
      if (!s.has(val)) throw new _jac.exc.KeyError("KeyError: " + val);
      s.delete(val);
    },
    pop(s) {
      if (s.size === 0) throw new _jac.exc.KeyError("pop from an empty set");
      const val = s.values().next().value;
      s.delete(val);
      return val;
    },
    update(s, other) { for (const v of other) s.add(v); },
    intersection_update(s, other) {
      const otherSet = other instanceof Set ? other : new Set(other);
      for (const v of s) { if (!otherSet.has(v)) s.delete(v); }
    },
    difference_update(s, other) {
      for (const v of other) s.delete(v);
    },
    symmetric_difference_update(s, other) {
      for (const v of other) { if (s.has(v)) s.delete(v); else s.add(v); }
    },
    union(a, b) {
      const r = new Set(a);
      for (const v of b) r.add(v);
      return r;
    },
    intersection(a, b) {
      const bs = b instanceof Set ? b : new Set(b);
      const r = new Set();
      for (const v of a) { if (bs.has(v)) r.add(v); }
      return r;
    },
    difference(a, b) {
      const bs = b instanceof Set ? b : new Set(b);
      const r = new Set();
      for (const v of a) { if (!bs.has(v)) r.add(v); }
      return r;
    },
    symmetricDifference(a, b) {
      const r = new Set(a);
      for (const v of b) { if (r.has(v)) r.delete(v); else r.add(v); }
      return r;
    },
    isSubsetOf(a, b) {
      if (a.size > b.size) return false;
      for (const v of a) { if (!b.has(v)) return false; }
      return true;
    },
    isSupersetOf(a, b) { return _jac.set.isSubsetOf(b, a); },
    isDisjointFrom(a, b) {
      for (const v of a) { if (b.has(v)) return false; }
      return true;
    },
    is_proper_subset(a, b) {
      if (a.size >= b.size) return false;
      for (const v of a) { if (!b.has(v)) return false; }
      return true;
    },
    is_proper_superset(a, b) { return _jac.set.is_proper_subset(b, a); },
    eq(a, b) {
      if (a.size !== b.size) return false;
      for (const v of a) { if (!b.has(v)) return false; }
      return true;
    }
  },

  bytes: {
    hex(b) {
      return Array.from(b).map(x => x.toString(16).padStart(2, "0")).join("");
    },
    fromhex(s) {
      const arr = [];
      const clean = s.replace(/\s/g, "");
      for (let i = 0; i < clean.length; i += 2) arr.push(parseInt(clean.substr(i, 2), 16));
      return new Uint8Array(arr);
    },
    _indexOf(b, sub, start, end) {
      const s = start || 0;
      const e = end === undefined ? b.length : end;
      const sl = sub.length;
      if (sl === 0) return s;
      for (let i = s; i <= e - sl; i++) {
        let m = true;
        for (let j = 0; j < sl; j++) { if (b[i + j] !== sub[j]) { m = false; break; } }
        if (m) return i;
      }
      return -1;
    },
    _lastIndexOf(b, sub, start, end) {
      const s = start || 0;
      const e = end === undefined ? b.length : end;
      const sl = sub.length;
      if (sl === 0) return e;
      for (let i = e - sl; i >= s; i--) {
        let m = true;
        for (let j = 0; j < sl; j++) { if (b[i + j] !== sub[j]) { m = false; break; } }
        if (m) return i;
      }
      return -1;
    },
    count(b, sub) {
      let c = 0, p = 0;
      while (p <= b.length - sub.length) {
        const idx = _jac.bytes._indexOf(b, sub, p);
        if (idx === -1) break;
        c++; p = idx + sub.length;
      }
      return c;
    },
    find(b, sub, start, end) { return _jac.bytes._indexOf(b, sub, start, end); },
    rfind(b, sub, start, end) { return _jac.bytes._lastIndexOf(b, sub, start, end); },
    index(b, sub, start, end) {
      const idx = _jac.bytes._indexOf(b, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    rindex(b, sub, start, end) {
      const idx = _jac.bytes._lastIndexOf(b, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    startswith(b, prefix, start, end) {
      const s = start || 0;
      if (prefix.length > b.length - s) return false;
      for (let i = 0; i < prefix.length; i++) { if (b[s + i] !== prefix[i]) return false; }
      return true;
    },
    endswith(b, suffix, start, end) {
      const e = end === undefined ? b.length : end;
      if (suffix.length > e) return false;
      const off = e - suffix.length;
      for (let i = 0; i < suffix.length; i++) { if (b[off + i] !== suffix[i]) return false; }
      return true;
    },
    replace(b, old_, new_, count) {
      const r = [];
      let pos = 0, n = 0;
      const max = count === undefined ? Infinity : count;
      while (pos <= b.length) {
        if (n < max) {
          const idx = _jac.bytes._indexOf(b, old_, pos);
          if (idx !== -1) {
            for (let i = pos; i < idx; i++) r.push(b[i]);
            for (let i = 0; i < new_.length; i++) r.push(new_[i]);
            pos = idx + old_.length; n++;
            continue;
          }
        }
        for (let i = pos; i < b.length; i++) r.push(b[i]);
        break;
      }
      return new Uint8Array(r);
    },
    _isWS(c) { return c === 32 || c === 9 || c === 10 || c === 13 || c === 11 || c === 12; },
    strip(b, chars) {
      let s = 0, e = b.length;
      if (chars) { const cs = new Set(chars); while (s < e && cs.has(b[s])) s++; while (e > s && cs.has(b[e-1])) e--; }
      else { while (s < e && _jac.bytes._isWS(b[s])) s++; while (e > s && _jac.bytes._isWS(b[e-1])) e--; }
      return b.slice(s, e);
    },
    lstrip(b, chars) {
      let s = 0;
      if (chars) { const cs = new Set(chars); while (s < b.length && cs.has(b[s])) s++; }
      else { while (s < b.length && _jac.bytes._isWS(b[s])) s++; }
      return b.slice(s);
    },
    rstrip(b, chars) {
      let e = b.length;
      if (chars) { const cs = new Set(chars); while (e > 0 && cs.has(b[e-1])) e--; }
      else { while (e > 0 && _jac.bytes._isWS(b[e-1])) e--; }
      return b.slice(0, e);
    },
    removeprefix(b, prefix) {
      if (_jac.bytes.startswith(b, prefix)) return b.slice(prefix.length);
      return b.slice();
    },
    removesuffix(b, suffix) {
      if (suffix.length > 0 && _jac.bytes.endswith(b, suffix)) return b.slice(0, b.length - suffix.length);
      return b.slice();
    },
    split(b, sep, maxsplit) {
      const parts = [];
      let pos = 0, n = 0;
      const max = maxsplit === undefined ? Infinity : maxsplit;
      while (pos <= b.length) {
        if (n >= max) { parts.push(b.slice(pos)); return parts; }
        const idx = _jac.bytes._indexOf(b, sep, pos);
        if (idx === -1) { parts.push(b.slice(pos)); return parts; }
        parts.push(b.slice(pos, idx));
        pos = idx + sep.length; n++;
      }
      if (pos <= b.length) parts.push(b.slice(pos));
      return parts;
    },
    rsplit(b, sep, maxsplit) {
      if (maxsplit === undefined) return _jac.bytes.split(b, sep);
      const parts = [];
      let end = b.length, n = 0;
      while (end >= 0 && n < maxsplit) {
        const idx = _jac.bytes._lastIndexOf(b, sep, 0, end);
        if (idx === -1) break;
        parts.unshift(b.slice(idx + sep.length, end));
        end = idx; n++;
      }
      parts.unshift(b.slice(0, end));
      return parts;
    },
    splitlines(b, keepends) {
      const result = [];
      let start = 0;
      for (let i = 0; i < b.length; i++) {
        if (b[i] === 10 || b[i] === 13) {
          let eol = i + 1;
          if (b[i] === 13 && i + 1 < b.length && b[i + 1] === 10) eol++;
          result.push(keepends ? b.slice(start, eol) : b.slice(start, i));
          start = eol;
          if (eol > i + 1) i++;
        }
      }
      if (start < b.length) result.push(b.slice(start));
      return result;
    },
    join(sep, parts) {
      if (parts.length === 0) return new Uint8Array(0);
      const r = [];
      for (let i = 0; i < parts.length; i++) {
        if (i > 0) for (const x of sep) r.push(x);
        for (const x of parts[i]) r.push(x);
      }
      return new Uint8Array(r);
    },
    partition(b, sep) {
      const idx = _jac.bytes._indexOf(b, sep);
      if (idx === -1) return [b.slice(), new Uint8Array(0), new Uint8Array(0)];
      return [b.slice(0, idx), sep.slice(), b.slice(idx + sep.length)];
    },
    rpartition(b, sep) {
      const idx = _jac.bytes._lastIndexOf(b, sep);
      if (idx === -1) return [new Uint8Array(0), new Uint8Array(0), b.slice()];
      return [b.slice(0, idx), sep.slice(), b.slice(idx + sep.length)];
    },
    _isUp(c) { return c >= 65 && c <= 90; },
    _isLo(c) { return c >= 97 && c <= 122; },
    _isAl(c) { return (c >= 65 && c <= 90) || (c >= 97 && c <= 122); },
    _isDig(c) { return c >= 48 && c <= 57; },
    capitalize(b) {
      if (b.length === 0) return new Uint8Array(0);
      const r = new Uint8Array(b.length);
      r[0] = _jac.bytes._isLo(b[0]) ? b[0] - 32 : b[0];
      for (let i = 1; i < b.length; i++) r[i] = _jac.bytes._isUp(b[i]) ? b[i] + 32 : b[i];
      return r;
    },
    lower(b) {
      const r = new Uint8Array(b.length);
      for (let i = 0; i < b.length; i++) r[i] = _jac.bytes._isUp(b[i]) ? b[i] + 32 : b[i];
      return r;
    },
    upper(b) {
      const r = new Uint8Array(b.length);
      for (let i = 0; i < b.length; i++) r[i] = _jac.bytes._isLo(b[i]) ? b[i] - 32 : b[i];
      return r;
    },
    title(b) {
      const r = new Uint8Array(b.length);
      let prev = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isAl(b[i])) {
          r[i] = prev ? (_jac.bytes._isUp(b[i]) ? b[i] + 32 : b[i]) : (_jac.bytes._isLo(b[i]) ? b[i] - 32 : b[i]);
          prev = true;
        } else { r[i] = b[i]; prev = false; }
      }
      return r;
    },
    swapcase(b) {
      const r = new Uint8Array(b.length);
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isUp(b[i])) r[i] = b[i] + 32;
        else if (_jac.bytes._isLo(b[i])) r[i] = b[i] - 32;
        else r[i] = b[i];
      }
      return r;
    },
    center(b, width, fb) {
      const f = fb || 32;
      if (b.length >= width) return b.slice();
      const total = width - b.length;
      const left = Math.floor(total / 2);
      const r = new Uint8Array(width);
      r.fill(f, 0, left); r.set(b, left); r.fill(f, left + b.length);
      return r;
    },
    ljust(b, width, fb) {
      const f = fb || 32;
      if (b.length >= width) return b.slice();
      const r = new Uint8Array(width);
      r.set(b); r.fill(f, b.length);
      return r;
    },
    rjust(b, width, fb) {
      const f = fb || 32;
      if (b.length >= width) return b.slice();
      const r = new Uint8Array(width);
      const off = width - b.length;
      r.fill(f, 0, off); r.set(b, off);
      return r;
    },
    zfill(b, width) {
      if (b.length >= width) return b.slice();
      const r = new Uint8Array(width);
      let off = 0;
      if (b.length > 0 && (b[0] === 43 || b[0] === 45)) { r[0] = b[0]; off = 1; }
      const pad = width - b.length;
      r.fill(48, off, off + pad);
      for (let i = off; i < b.length; i++) r[pad + i] = b[i];
      return r;
    },
    expandtabs(b, tabsize) {
      const ts = tabsize === undefined ? 8 : tabsize;
      const r = [];
      let col = 0;
      for (let i = 0; i < b.length; i++) {
        if (b[i] === 9) { const sp = ts - (col % ts); for (let j = 0; j < sp; j++) r.push(32); col += sp; }
        else if (b[i] === 10 || b[i] === 13) { r.push(b[i]); col = 0; }
        else { r.push(b[i]); col++; }
      }
      return new Uint8Array(r);
    },
    translate(b, table, del_) {
      const r = [];
      const ds = del_ ? new Set(del_) : null;
      for (let i = 0; i < b.length; i++) {
        if (ds && ds.has(b[i])) continue;
        r.push(table && table[b[i]] !== undefined ? table[b[i]] : b[i]);
      }
      return new Uint8Array(r);
    },
    maketrans(from_, to_) {
      const t = new Uint8Array(256);
      for (let i = 0; i < 256; i++) t[i] = i;
      for (let i = 0; i < from_.length; i++) t[from_[i]] = to_[i];
      return t;
    },
    isalnum(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isAl(b[i]) && !_jac.bytes._isDig(b[i])) return false;
      return true;
    },
    isalpha(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isAl(b[i])) return false;
      return true;
    },
    isascii(b) {
      for (let i = 0; i < b.length; i++) if (b[i] > 127) return false;
      return true;
    },
    isdigit(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isDig(b[i])) return false;
      return true;
    },
    islower(b) {
      let has = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isUp(b[i])) return false;
        if (_jac.bytes._isLo(b[i])) has = true;
      }
      return has;
    },
    isupper(b) {
      let has = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isLo(b[i])) return false;
        if (_jac.bytes._isUp(b[i])) has = true;
      }
      return has;
    },
    isspace(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isWS(b[i])) return false;
      return true;
    },
    istitle(b) {
      let prev = false, has = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isUp(b[i])) { if (prev) return false; prev = true; has = true; }
        else if (_jac.bytes._isLo(b[i])) { if (!prev) return false; prev = true; has = true; }
        else prev = false;
      }
      return has;
    },
    add(a, b) {
      const r = new Uint8Array(a.length + b.length);
      r.set(a); r.set(b, a.length);
      return r;
    },
    mul(b, n) {
      const r = new Uint8Array(b.length * n);
      for (let i = 0; i < n; i++) r.set(b, i * b.length);
      return r;
    },
    mod(b, args) {
      const s = new TextDecoder().decode(b);
      return new TextEncoder().encode(_jac.str.mod(s, args));
    },
    eq(a, b) {
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
      return true;
    },
    lt(a, b) {
      for (let i = 0; i < Math.min(a.length, b.length); i++) {
        if (a[i] < b[i]) return true;
        if (a[i] > b[i]) return false;
      }
      return a.length < b.length;
    },
    gt(a, b) { return _jac.bytes.lt(b, a); },
    le(a, b) { return _jac.bytes.eq(a, b) || _jac.bytes.lt(a, b); },
    ge(a, b) { return _jac.bytes.eq(a, b) || _jac.bytes.gt(a, b); },
    contains(b, sub) { return _jac.bytes._indexOf(b, sub) !== -1; }
  },

  tuple: {
    count(arr, val) { return _jac.list.count(arr, val); },
    index(arr, val, start, end) { return _jac.list.index(arr, val, start, end); },
    repeat(arr, n) { return _jac.list.repeat(arr, n); },
    eq(a, b) { return _jac.list.eq(a, b); },
    lt(a, b) { return _jac.list.lt(a, b); },
    gt(a, b) { return _jac.list.gt(a, b); },
    le(a, b) { return _jac.list.le(a, b); },
    ge(a, b) { return _jac.list.ge(a, b); }
  },

  range: {
    count(r, val) {
      if (typeof r[Symbol.iterator] === "function") {
        let c = 0;
        for (const v of r) { if (v === val) c++; }
        return c;
      }
      return 0;
    },
    index(r, val) {
      let i = 0;
      for (const v of r) { if (v === val) return i; i++; }
      throw new _jac.exc.ValueError(val + " is not in range");
    },
    eq(a, b) {
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) { if (a[i] !== b[i]) return false; }
      return true;
    },
    contains(r, val) {
      for (const v of r) { if (v === val) return true; }
      return false;
    }
  },

  builtin: {
    round(n, ndigits) {
      if (ndigits === undefined) return Math.round(n);
      const f = Math.pow(10, ndigits);
      return Math.round(n * f) / f;
    },
    sum(iterable, start) {
      let total = start || 0;
      for (const v of iterable) total += v;
      return total;
    },
    sorted(iterable, key, reverse) {
      const arr = [...iterable];
      if (key) {
        arr.sort((a, b) => {
          const ka = key(a), kb = key(b);
          return ka < kb ? -1 : ka > kb ? 1 : 0;
        });
      } else {
        arr.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
      }
      if (reverse) arr.reverse();
      return arr;
    },
    enumerate(iterable, start) {
      const s = start || 0;
      return [...iterable].map((v, i) => [s + i, v]);
    },
    zip(...iterables) {
      const arrays = iterables.map(it => [...it]);
      const len = Math.min(...arrays.map(a => a.length));
      const result = [];
      for (let i = 0; i < len; i++) {
        result.push(arrays.map(a => a[i]));
      }
      return result;
    },
    map(fn, ...iterables) {
      if (iterables.length === 1) return [...iterables[0]].map(fn);
      const arrays = iterables.map(it => [...it]);
      const len = Math.min(...arrays.map(a => a.length));
      const result = [];
      for (let i = 0; i < len; i++) {
        result.push(fn(...arrays.map(a => a[i])));
      }
      return result;
    },
    filter(fn, iterable) {
      return [...iterable].filter(fn || (x => x));
    },
    // Python subclass relation over builtin-type *tags* -- the string names
    // (`"str"`, `"int"`, ...) that `exit_builtin_type` lowers builtin types to.
    // `object` is the universal base and `bool` is a subclass of `int`; `tuple`
    // and `frozenset` share JS representations with `list`/`set`, so fold those
    // aliases to their runtime tag first. One source of truth so isinstance and
    // issubclass can never disagree.
    _tagSubclass(subTag, superTag) {
      const fold = (t) => t === "tuple" ? "list" : t === "frozenset" ? "set" : t;
      const sub = fold(subTag), sup = fold(superTag);
      if (sup === "object") return true;
      if (sub === sup) return true;
      if (sup === "int" && sub === "bool") return true;
      return false;
    },
    isinstance(o, classinfo) {
      // isinstance(x, (A, B, ...)) -- the tuple of types lowers to a JS array;
      // match if `o` is an instance of any member.
      if (Array.isArray(classinfo)) {
        for (const c of classinfo) {
          if (_jac.builtin.isinstance(o, c)) return true;
        }
        return false;
      }
      // Builtin types lower to a string tag (their Python type name): compare
      // the value's runtime type against it via the shared subclass relation.
      if (typeof classinfo === "string") {
        return _jac.builtin._tagSubclass(_jac.poly._typename(o), classinfo);
      }
      // User archetype / JS constructor.
      if (typeof classinfo === "function") return o instanceof classinfo;
      return false;
    },
    issubclass(cls, classinfo) {
      if (Array.isArray(classinfo)) {
        for (const c of classinfo) {
          if (_jac.builtin.issubclass(cls, c)) return true;
        }
        return false;
      }
      // When either side is a builtin-type tag, compare by the shared subclass
      // relation (covers `object`, `bool` ⊂ `int`, and identity).
      if (typeof cls === "string" || typeof classinfo === "string") {
        return _jac.builtin._tagSubclass(cls, classinfo);
      }
      if (cls === classinfo) return true;
      let proto = cls;
      while (proto) {
        if (proto === classinfo) return true;
        proto = Object.getPrototypeOf(proto);
      }
      return false;
    },
    id(o) {
      if (o === null || o === undefined) return 0;
      if (typeof o === "number") return o;
      return typeof o === "string" ? _jac.builtin._strHash(o) : 0;
    },
    _strHash(s) {
      let h = 0;
      for (let i = 0; i < s.length; i++) {
        h = ((h << 5) - h + s.charCodeAt(i)) | 0;
      }
      return h;
    },
    jid(obj) {
      if (obj === null || obj === undefined) {
        throw new _jac.exc.TypeError(
          "jid() called on " + String(obj)
          + " -- the server may have returned an error instead of a node."
          + " Check that your endpoint returned successfully before using jid()."
        );
      }
      if (obj._jac_id === undefined) {
        throw new _jac.exc.TypeError(
          "jid() expected a node or edge with graph identity, but received "
          + (typeof obj === "object" ? JSON.stringify(Object.keys(obj)) : typeof obj)
          + ". Only node and edge archetypes have a jid."
        );
      }
      return obj._jac_id;
    },
    // unsafe_html(x) returns a sentinel object that the JSX flattener
    // recognises and renders as raw HTML via dangerouslySetInnerHTML.
    // Named "unsafe" so the security implication is visible at the use site.
    unsafe_html(html) {
      return { __jacUnsafeHtml: String(html == null ? "" : html) };
    },
    hash(obj) { return _jac.builtin.id(obj); },
    repr(obj) { return JSON.stringify(obj); },
    pow(base, exp, mod) {
      let result = Math.pow(base, exp);
      if (mod !== undefined) result = ((result % mod) + mod) % mod;
      return result;
    },
    next(iter, default_) {
      const result = iter.next();
      if (result.done) {
        if (default_ !== undefined) return default_;
        throw new _jac.exc.StopIteration("StopIteration");
      }
      return result.value;
    },
    vars(o) {
      if (o === undefined) return {};
      const result = {};
      for (const [k, v] of Object.entries(o)) {
        if (typeof v !== "function") result[k] = v;
      }
      return result;
    },
    dir(o) {
      if (o === undefined) return [];
      return Object.getOwnPropertyNames(o).sort();
    },
    open() { throw new _jac.exc.OSError("open() is not supported in client-side JavaScript"); },
    format(value, format_spec) {
      if (!format_spec) return String(value);
      return String(value);
    },
    ascii(obj) {
      if (typeof obj === "string") {
        let r = "'";
        for (const c of obj) {
          const code = c.charCodeAt(0);
          if (c === "\\") r += "\\\\";
          else if (c === "'") r += "\\'";
          else if (code >= 0x20 && code <= 0x7e) r += c;
          else if (code < 0x100) r += "\\x" + code.toString(16).padStart(2, "0");
          else r += "\\u" + code.toString(16).padStart(4, "0");
        }
        return r + "'";
      }
      return String(obj);
    },
    complex(re, im) { return {re: re || 0, im: im || 0}; },
    bool(x) {
      if (x === null || x === undefined || x === false || x === 0 || x === "" || Number.isNaN(x)) return false;
      if (Array.isArray(x)) return x.length > 0;
      if (x instanceof Set || x instanceof Map) return x.size > 0;
      if (typeof x === "object") return Object.keys(x).length > 0;
      return true;
    },
    range(...args) {
      let start, stop, step;
      if (args.length === 1) { start = 0; stop = args[0]; step = 1; }
      else if (args.length === 2) { start = args[0]; stop = args[1]; step = 1; }
      else { start = args[0]; stop = args[1]; step = args[2]; }
      if (step === 0) throw new _jac.exc.ValueError("range() arg 3 must not be zero");
      const result = [];
      if (step > 0) { for (let i = start; i < stop; i += step) result.push(i); }
      else { for (let i = start; i > stop; i += step) result.push(i); }
      return result;
    },
    slice(...args) {
      if (args.length === 1) return { start: null, stop: args[0], step: null };
      return { start: args[0] !== undefined ? args[0] : null, stop: args[1] !== undefined ? args[1] : null, step: args[2] !== undefined ? args[2] : null };
    },
    format(value, format_spec) {
      if (!format_spec || format_spec === "") return String(value);
      const m = format_spec.match(/^([<>^]?)(\d+)?(?:\.(\d+))?([dfseboxXn%]?)$/);
      if (!m) return String(value);
      const [, align, widthStr, precStr, ftype] = m;
      let s;
      const prec = precStr !== undefined ? parseInt(precStr) : undefined;
      if (ftype === "f" || ftype === "") {
        s = prec !== undefined ? Number(value).toFixed(prec) : String(value);
      } else if (ftype === "d") {
        s = String(Math.floor(Number(value)));
      } else if (ftype === "b") {
        s = Number(value).toString(2);
      } else if (ftype === "o") {
        s = Number(value).toString(8);
      } else if (ftype === "x") {
        s = Number(value).toString(16);
      } else if (ftype === "X") {
        s = Number(value).toString(16).toUpperCase();
      } else if (ftype === "e") {
        s = prec !== undefined ? Number(value).toExponential(prec) : Number(value).toExponential();
      } else if (ftype === "%") {
        s = (prec !== undefined ? (Number(value) * 100).toFixed(prec) : (Number(value) * 100).toFixed(6)) + "%";
      } else if (ftype === "s" || ftype === "n") {
        s = String(value);
      } else {
        s = String(value);
      }
      if (widthStr) {
        const width = parseInt(widthStr);
        if (s.length < width) {
          const pad = " ".repeat(width - s.length);
          if (align === "<") s = s + pad;
          else if (align === "^") {
            const left = Math.floor((width - s.length) / 2);
            s = " ".repeat(left) + s + " ".repeat(width - s.length - left);
          }
          else s = pad + s;
        }
      }
      return s;
    }
  },

  exc: (() => {
    class BaseException extends Error { constructor(m) { super(m); this.name = 'BaseException'; } }
    class Exception extends BaseException { constructor(m) { super(m); this.name = 'Exception'; } }
    class ArithmeticError extends Exception { constructor(m) { super(m); this.name = 'ArithmeticError'; } }
    class ZeroDivisionError extends ArithmeticError { constructor(m) { super(m); this.name = 'ZeroDivisionError'; } }
    class OverflowError extends ArithmeticError { constructor(m) { super(m); this.name = 'OverflowError'; } }
    class FloatingPointError extends ArithmeticError { constructor(m) { super(m); this.name = 'FloatingPointError'; } }
    class LookupError extends Exception { constructor(m) { super(m); this.name = 'LookupError'; } }
    class IndexError extends LookupError { constructor(m) { super(m); this.name = 'IndexError'; } }
    class KeyError extends LookupError { constructor(m) { super(m); this.name = 'KeyError'; } }
    class ValueError extends Exception { constructor(m) { super(m); this.name = 'ValueError'; } }
    class TypeError_ extends Exception { constructor(m) { super(m); this.name = 'TypeError'; } }
    class AttributeError extends Exception { constructor(m) { super(m); this.name = 'AttributeError'; } }
    class RuntimeError extends Exception { constructor(m) { super(m); this.name = 'RuntimeError'; } }
    class NotImplementedError extends RuntimeError { constructor(m) { super(m); this.name = 'NotImplementedError'; } }
    class RecursionError extends RuntimeError { constructor(m) { super(m); this.name = 'RecursionError'; } }
    class OSError extends Exception { constructor(m) { super(m); this.name = 'OSError'; } }
    class FileNotFoundError extends OSError { constructor(m) { super(m); this.name = 'FileNotFoundError'; } }
    class FileExistsError extends OSError { constructor(m) { super(m); this.name = 'FileExistsError'; } }
    class PermissionError extends OSError { constructor(m) { super(m); this.name = 'PermissionError'; } }
    class TimeoutError extends OSError { constructor(m) { super(m); this.name = 'TimeoutError'; } }
    class IsADirectoryError extends OSError { constructor(m) { super(m); this.name = 'IsADirectoryError'; } }
    class NotADirectoryError extends OSError { constructor(m) { super(m); this.name = 'NotADirectoryError'; } }
    class AssertionError extends Exception { constructor(m) { super(m); this.name = 'AssertionError'; } }
    class ImportError extends Exception { constructor(m) { super(m); this.name = 'ImportError'; } }
    class ModuleNotFoundError extends ImportError { constructor(m) { super(m); this.name = 'ModuleNotFoundError'; } }
    class NameError extends Exception { constructor(m) { super(m); this.name = 'NameError'; } }
    class UnboundLocalError extends NameError { constructor(m) { super(m); this.name = 'UnboundLocalError'; } }
    class StopIteration extends Exception { constructor(m) { super(m); this.name = 'StopIteration'; } }
    class StopAsyncIteration extends Exception { constructor(m) { super(m); this.name = 'StopAsyncIteration'; } }
    class EOFError extends Exception { constructor(m) { super(m); this.name = 'EOFError'; } }
    class MemoryError extends Exception { constructor(m) { super(m); this.name = 'MemoryError'; } }
    class ReferenceError_ extends Exception { constructor(m) { super(m); this.name = 'ReferenceError'; } }
    class KeyboardInterrupt extends BaseException { constructor(m) { super(m); this.name = 'KeyboardInterrupt'; } }
    class SystemExit extends BaseException { constructor(m) { super(m); this.name = 'SystemExit'; } }
    class GeneratorExit extends BaseException { constructor(m) { super(m); this.name = 'GeneratorExit'; } }
    return { BaseException, Exception, ArithmeticError, ZeroDivisionError, OverflowError, FloatingPointError, LookupError, IndexError, KeyError, ValueError, TypeError: TypeError_, AttributeError, RuntimeError, NotImplementedError, RecursionError, OSError, FileNotFoundError, FileExistsError, PermissionError, TimeoutError, IsADirectoryError, NotADirectoryError, AssertionError, ImportError, ModuleNotFoundError, NameError, UnboundLocalError, StopIteration, StopAsyncIteration, EOFError, MemoryError, ReferenceError: ReferenceError_, KeyboardInterrupt, SystemExit, GeneratorExit };
  })()
};
function SchedulerView(props) {
  const {schState, weekInfo, callbacks} = props;
  let schedule = useStoreSlice(getStoreSchedule, subscribeStoreSchedule);
  let fixedBlocks = useStoreSlice(getStoreFixedBlocks, subscribeStoreFixedBlocks);
  let energyData = useStoreSlice(getStoreEnergyData, subscribeStoreEnergyData);
  let schDirty = useStoreSlice(getStoreSchDirty, subscribeStoreSchDirty);
  let schOptimized = useStoreSlice(getStoreSchOptimized, subscribeStoreSchOptimized);
  let schLog = useStoreSlice(getStoreSchLog, subscribeStoreSchLog);
  let schOverflow = useStoreSlice(getStoreOverflow, subscribeStoreOverflow);
  let schSuggestions = useStoreSlice(getStoreSuggestions, subscribeStoreSuggestions);
  let schConstraints = useStoreSlice(getStoreSchConstraints, subscribeStoreSchConstraints);
  let schOverflowExpandedIds = useStoreSlice(getStoreSchOverflowExpandedIds, subscribeStoreSchOverflowExpandedIds);
  let schPopupOpen = useStoreSlice(getStoreSchPopupOpen, subscribeStoreSchPopupOpen);
  let schPopupBlock = useStoreSlice(getStoreSchPopupBlock, subscribeStoreSchPopupBlock);
  let schReasoningTarget = useStoreSlice(getStoreSchReasoningTarget, subscribeStoreSchReasoningTarget);
  let isAdmin = useStoreSlice(getStoreIsAdmin, subscribeStoreIsAdmin);
  let schDevScenarioActive = useStoreSlice(getStoreSchDevScenarioActive, subscribeStoreSchDevScenarioActive);
  let gcalStatus = useStoreSlice(getStoreGcalStatus, subscribeStoreGcalStatus);
  let gcalSyncing = useStoreSlice(getStoreGcalSyncing, subscribeStoreGcalSyncing);
  let _gcalClock = useStoreSlice(getStoreGcalClock, subscribeStoreGcalClock);
  let coachMarkStep = useStoreSlice(getStoreCoachMarkStep, subscribeStoreCoachMarkStep);
  let devSyncScheduleAfterOptimize = useStoreSlice(getStoreDevSyncScheduleAfterOptimize, subscribeStoreDevSyncScheduleAfterOptimize);
  let schPrefPeak = useStoreSlice(getStoreSchPrefPeak, subscribeStoreSchPrefPeak);
  let schPrefBlock = useStoreSlice(getStoreSchPrefBlock, subscribeStoreSchPrefBlock);
  let schPrefBuf = useStoreSlice(getStoreSchPrefBuf, subscribeStoreSchPrefBuf);
  let schPrefStrat = useStoreSlice(getStoreSchPrefStrat, subscribeStoreSchPrefStrat);
  let schPrefAfter = useStoreSlice(getStoreSchPrefAfter, subscribeStoreSchPrefAfter);
  let selectedDay = useStoreSlice(getStoreSelectedDay, subscribeStoreSelectedDay);
  let isMobileViewport = useStoreSlice(getStoreIsMobileViewport, subscribeStoreIsMobileViewport);
  let mobileSchedView = useStoreSlice(getStoreMobileSchedView, subscribeStoreMobileSchedView);
  let mobileSandboxToast = useStoreSlice(getStoreMobileSandboxToast, subscribeStoreMobileSandboxToast);
  let _showSbToast = msg => {
    setStoreMobileSandboxToast(msg);
    try {
      if (window.__skoochSbToastTimer) {
        clearTimeout(window.__skoochSbToastTimer);
      }
    } catch (__jac_e) {
      if (true) {
        let _e = __jac_e;
      } else {
        throw __jac_e;
      }
    }
    try {
      window.__skoochSbToastTimer = setTimeout(() => {
        setStoreMobileSandboxToast("");
      }, 5500);
    } catch (__jac_e) {
      if (true) {
        let _e2 = __jac_e;
      } else {
        throw __jac_e;
      }
    }
  };
  let schEditTitle = useStoreSlice(getStoreSchEditTitle, subscribeStoreSchEditTitle);
  let schEditPri = useStoreSlice(getStoreSchEditPri, subscribeStoreSchEditPri);
  let schEditDL = useStoreSlice(getStoreSchEditDL, subscribeStoreSchEditDL);
  let schEditDur = useStoreSlice(getStoreSchEditDur, subscribeStoreSchEditDur);
  let schEditCat = useStoreSlice(getStoreSchEditCat, subscribeStoreSchEditCat);
  let schEditLoc = useStoreSlice(getStoreSchEditLoc, subscribeStoreSchEditLoc);
  let schEditStart = useStoreSlice(getStoreSchEditStart, subscribeStoreSchEditStart);
  let schEditEnd = useStoreSlice(getStoreSchEditEnd, subscribeStoreSchEditEnd);
  let schEditDay = useStoreSlice(getStoreSchEditDay, subscribeStoreSchEditDay);
  let schEditDays = useStoreSlice(getStoreSchEditDays, subscribeStoreSchEditDays);
  let schEditDate = useStoreSlice(getStoreSchEditDate, subscribeStoreSchEditDate);
  let schPopupDirty = useStoreSlice(getStoreSchPopupDirty, subscribeStoreSchPopupDirty);
  let schPopupSaveState = useStoreSlice(getStoreSchPopupSaveState, subscribeStoreSchPopupSaveState);
  let schReportOpen = useStoreSlice(getStoreSchReportOpen, subscribeStoreSchReportOpen);
  let schFormError = useStoreSlice(getStoreSchFormError, subscribeStoreSchFormError);
  let profileComplete = (("profileComplete" in schState) ? schState["profileComplete"] : true);
  let devMode = useStoreSlice(getStoreDevMode, subscribeStoreDevMode);
  let schSidebarMode = useStoreSlice(getStoreSchSidebarMode, subscribeStoreSchSidebarMode);
  let schFixedEventRows = schState["schFixedEventRows"];
  let schZoom = useStoreSlice(getStoreSchZoom, subscribeStoreSchZoom);
  let _HOUR_HEIGHTS = [20, 35, 60, 90, 130];
  let _hourHeight = (((schZoom >= 0) && (schZoom <= 4)) ? _HOUR_HEIGHTS.at(schZoom) : 60);
  let schTaskName = useStoreSlice(getStoreSchTaskName, subscribeStoreSchTaskName);
  let schTaskCat = useStoreSlice(getStoreSchTaskCat, subscribeStoreSchTaskCat);
  let schTaskDur = useStoreSlice(getStoreSchTaskDur, subscribeStoreSchTaskDur);
  let schTaskDurH = useStoreSlice(getStoreSchTaskDurH, subscribeStoreSchTaskDurH);
  let schTaskDurM = useStoreSlice(getStoreSchTaskDurM, subscribeStoreSchTaskDurM);
  let schTaskPri = useStoreSlice(getStoreSchTaskPri, subscribeStoreSchTaskPri);
  let schTaskDL = useStoreSlice(getStoreSchTaskDL, subscribeStoreSchTaskDL);
  let schTaskIsRecurring = useStoreSlice(getStoreSchTaskIsRecurring, subscribeStoreSchTaskIsRecurring);
  let schTaskRecurrenceInterval = useStoreSlice(getStoreSchTaskRecurrenceInterval, subscribeStoreSchTaskRecurrenceInterval);
  let schTaskRecurrenceUnit = useStoreSlice(getStoreSchTaskRecurrenceUnit, subscribeStoreSchTaskRecurrenceUnit);
  let schTaskRecurrenceWeekday = useStoreSlice(getStoreSchTaskRecurrenceWeekday, subscribeStoreSchTaskRecurrenceWeekday);
  let schEvName = useStoreSlice(getStoreSchEvName, subscribeStoreSchEvName);
  let schEvCat = useStoreSlice(getStoreSchEvCat, subscribeStoreSchEvCat);
  let schEvLoc = useStoreSlice(getStoreSchEvLoc, subscribeStoreSchEvLoc);
  let schEvStart = useStoreSlice(getStoreSchEvStart, subscribeStoreSchEvStart);
  let schEvEnd = useStoreSlice(getStoreSchEvEnd, subscribeStoreSchEvEnd);
  let schEvIsRecurring = useStoreSlice(getStoreSchEvIsRecurring, subscribeStoreSchEvIsRecurring);
  let schEvIsAllDay = useStoreSlice(getStoreSchEvIsAllDay, subscribeStoreSchEvIsAllDay);
  let schEvRecurrenceInterval = useStoreSlice(getStoreSchEvRecurrenceInterval, subscribeStoreSchEvRecurrenceInterval);
  let schEvRecurrenceUnit = useStoreSlice(getStoreSchEvRecurrenceUnit, subscribeStoreSchEvRecurrenceUnit);
  let schEvDate = useStoreSlice(getStoreSchEvDate, subscribeStoreSchEvDate);
  let schEvMon = useStoreSlice(getStoreSchEvMon, subscribeStoreSchEvMon);
  let schEvTue = useStoreSlice(getStoreSchEvTue, subscribeStoreSchEvTue);
  let schEvWed = useStoreSlice(getStoreSchEvWed, subscribeStoreSchEvWed);
  let schEvThu = useStoreSlice(getStoreSchEvThu, subscribeStoreSchEvThu);
  let schEvFri = useStoreSlice(getStoreSchEvFri, subscribeStoreSchEvFri);
  let schEvSat = useStoreSlice(getStoreSchEvSat, subscribeStoreSchEvSat);
  let schEvSun = useStoreSlice(getStoreSchEvSun, subscribeStoreSchEvSun);
  let schConType = useStoreSlice(getStoreSchConType, subscribeStoreSchConType);
  let schConStart = useStoreSlice(getStoreSchConStart, subscribeStoreSchConStart);
  let schConEnd = useStoreSlice(getStoreSchConEnd, subscribeStoreSchConEnd);
  let schConCat = useStoreSlice(getStoreSchConCat, subscribeStoreSchConCat);
  let schConMax = useStoreSlice(getStoreSchConMax, subscribeStoreSchConMax);
  let schConMon = useStoreSlice(getStoreSchConMon, subscribeStoreSchConMon);
  let schConTue = useStoreSlice(getStoreSchConTue, subscribeStoreSchConTue);
  let schConWed = useStoreSlice(getStoreSchConWed, subscribeStoreSchConWed);
  let schConThu = useStoreSlice(getStoreSchConThu, subscribeStoreSchConThu);
  let schConFri = useStoreSlice(getStoreSchConFri, subscribeStoreSchConFri);
  let schConSat = useStoreSlice(getStoreSchConSat, subscribeStoreSchConSat);
  let schConSun = useStoreSlice(getStoreSchConSun, subscribeStoreSchConSun);
  let _dayDates = weekInfo["_dayDates"];
  let _dayNames = weekInfo["_dayNames"];
  let _isCurrentWeek = weekInfo["_isCurrentWeek"];
  let _todayIdx = weekInfo["_todayIdx"];
  let _weekLabel = (("_weekLabel" in weekInfo) ? weekInfo["_weekLabel"] : "");
  let _weekIsoDays = (("_weekIsoDays" in weekInfo) ? weekInfo["_weekIsoDays"] : []);
  if ((schSidebarMode === "parking")) {
    schSidebarMode = "lot";
  }
  let setSchPref = callbacks["setSchPref"];
  let applySchZoom = (("applySchZoom" in callbacks) ? callbacks["applySchZoom"] : _z => {});
  let addSchTask = callbacks["addSchTask"];
  let removeSchTask = callbacks["removeSchTask"];
  let addSchEvent = callbacks["addSchEvent"];
  let removeSchEvent = callbacks["removeSchEvent"];
  let addSchConstraint = callbacks["addSchConstraint"];
  let removeSchConstraint = callbacks["removeSchConstraint"];
  let openSchPopup = callbacks["openSchPopup"];
  let closeSchPopup = callbacks["closeSchPopup"];
  let saveSchPopupEdits = callbacks["saveSchPopupEdits"];
  let saveSchPopupFixedEdits = (("saveSchPopupFixedEdits" in callbacks) ? callbacks["saveSchPopupFixedEdits"] : () => {});
  let removeSchPopupBlock = callbacks["removeSchPopupBlock"];
  let runOptimize = callbacks["runOptimize"];
  let runRandomize = callbacks["runRandomize"];
  let runStressTest = callbacks["runStressTest"];
  let exitSandbox = (("exitSandbox" in callbacks) ? callbacks["exitSandbox"] : () => {});
  let onContinueAsGuest = (("onContinueAsGuest" in callbacks) ? callbacks["onContinueAsGuest"] : null);
  let onFinishProfile = (("onFinishProfile" in callbacks) ? callbacks["onFinishProfile"] : null);
  let applySuggestion = callbacks["applySuggestion"];
  let viewDayInDashboard = callbacks["viewDayInDashboard"];
  let orderedSchTasks = callbacks["orderedSchTasks"];
  let schTasksSidebarCount = callbacks["schTasksSidebarCount"];
  let toggleOverflowDetails = callbacks["toggleOverflowDetails"];
  let taskCategoryLabel = callbacks["taskCategoryLabel"];
  let dayListLabel = callbacks["dayListLabel"];
  let mergeContiguousChunks = callbacks["mergeContiguousChunks"];
  let schCatColor = callbacks["schCatColor"];
  let onFormChange = callbacks["onFormChange"];
  let onStateChange = callbacks["onStateChange"];
  let onPrevWeek = (("onPrevWeek" in callbacks) ? callbacks["onPrevWeek"] : _ignored => {});
  let onNextWeek = (("onNextWeek" in callbacks) ? callbacks["onNextWeek"] : _ignored => {});
  let placeSchTask = (("placeSchTask" in callbacks) ? callbacks["placeSchTask"] : (_tid, _day, _mins) => {});
  let acceptScheduledTask = (("acceptScheduledTask" in callbacks) ? callbacks["acceptScheduledTask"] : _tid => {});
  let rejectScheduledTask = (("rejectScheduledTask" in callbacks) ? callbacks["rejectScheduledTask"] : _tid => {});
  let deleteTaskAndPlacements = (("deleteTaskAndPlacements" in callbacks) ? callbacks["deleteTaskAndPlacements"] : _tid => {});
  let acceptAllPlacements = (("acceptAllPlacements" in callbacks) ? callbacks["acceptAllPlacements"] : () => {});
  function schMaxDailyCapsDesc(constraints) {
    let caps = [];
    for (const con of constraints) {
      if ((con.type === "max_daily_hours")) {
        caps = caps.concat([con.max_hours]);
      }
    }
    if ((caps.length === 0)) {
      return "";
    }
    let lo = caps[0];
    let hi = caps[0];
    for (const c of caps) {
      if ((c < lo)) {
        lo = c;
      }
      if ((c > hi)) {
        hi = c;
      }
    }
    if ((lo === hi)) {
      return (String(lo) + " h/day");
    }
    return (((String(lo) + "\u2013") + String(hi)) + " h/day");
  }
  function schSuggestionLines(sg, constraints, bufferMins) {
    let action = sg.action;
    if (((action === "extend_earlier") || (action === "extend_later"))) {
      let capDesc = schMaxDailyCapsDesc(constraints);
      let line2 = ((capDesc.length > 0) ? (("Current limits: " + capDesc) + " \u2192 each max-daily-hours rule goes up by 1") : "No max daily hours rule in this scenario yet; add one under Constraints for this to do anything.");
      return {"line1": ((action === "extend_earlier") ? "Increase early-day scheduling capacity by 1h/day" : "Increase late-day scheduling capacity by 1h/day"), "line2": line2};
    }
    if (((action === "remove_buffer") && (bufferMins > 0))) {
      return {"line1": "Remove buffer between blocks", "line2": (("Buffer " + String(bufferMins)) + " min \u2192 0")};
    }
    if ((action === "drop_task")) {
      return {"line1": sg.text, "line2": (sg.freed ? (("Frees ~" + String(sg.freed)) + " min") : "")};
    }
    return {"line1": sg.text, "line2": (sg.freed ? (("Frees ~" + String(sg.freed)) + " min") : "")};
  }
  let visibleSuggestions = schSuggestions.filter(sg => {
    let action = ((sg && sg.action) ? sg.action : "");
    if ((((action === "extend_earlier") || (action === "extend_later")) && (schMaxDailyCapsDesc(schConstraints).length === 0))) {
      return false;
    }
    if (((action === "remove_buffer") && (schPrefBuf <= 0))) {
      return false;
    }
    return true;
  });
  let schPopupIsExternal = false;
  if (((schPopupBlock && schPopupBlock.source) && (schPopupBlock.source !== "manual"))) {
    schPopupIsExternal = true;
  }
  let schPopupIsRecurringFixed = false;
  if ((((schPopupBlock && schPopupBlock.is_fixed) && schEditDays) && (schEditDays.length > 0))) {
    schPopupIsRecurringFixed = true;
  }
  let schPopupIsExternalRecurring = false;
  if ((schPopupBlock && ((schPopupBlock.rrule || schPopupBlock.is_recurring) || (schEditDays && (schEditDays.length > 0))))) {
    schPopupIsExternalRecurring = true;
  }
  let schPopupIsExternalOneoff = (schPopupIsExternal && !schPopupIsExternalRecurring);
  let fixedForWeek = [];
  for (const b of dedupeFixedBlocks(fixedBlocks)) {
    let sd = ((_jac.poly.contains(b, "scheduled_date") && b["scheduled_date"]) ? b["scheduled_date"] : "");
    if (sd) {
      let idx = (-1);
      for (const i of [0, 1, 2, 3, 4, 5, 6]) {
        if (((i < _weekIsoDays.length) && (_jac.poly.getitem(_weekIsoDays, i) === sd))) {
          idx = i;
        }
      }
      if ((idx >= 0)) {
        let bb = {};
        for (const k of _jac.poly.call(Object, "keys", b)) {
          bb[k] = _jac.poly.getitem(b, k);
        }
        bb["day"] = (idx + 1);
        fixedForWeek = fixedForWeek.concat([bb]);
      }
    } else {
      fixedForWeek = fixedForWeek.concat([b]);
    }
  }
  let scheduleForWeek = [];
  for (const b of schedule) {
    let sd = ((_jac.poly.contains(b, "scheduled_date") && b["scheduled_date"]) ? b["scheduled_date"] : "");
    if (sd) {
      let idx = (-1);
      for (const i of [0, 1, 2, 3, 4, 5, 6]) {
        if (((i < _weekIsoDays.length) && (_jac.poly.getitem(_weekIsoDays, i) === sd))) {
          idx = i;
        }
      }
      if ((idx >= 0)) {
        let bb = {};
        for (const k of _jac.poly.call(Object, "keys", b)) {
          bb[k] = _jac.poly.getitem(b, k);
        }
        bb["day"] = (idx + 1);
        scheduleForWeek = scheduleForWeek.concat([bb]);
      }
    } else {
      if (_isCurrentWeek) {
        scheduleForWeek = scheduleForWeek.concat([b]);
      }
    }
  }
  let schAllCal = scheduleForWeek.concat(fixedForWeek);
  let _staleCount = 0;
  if ((_isCurrentWeek && !schDevScenarioActive)) {
    let _staleInfo = computeStalePlacements(schedule, getStoreTasks(), _weekIsoDays);
    _staleCount = (_jac.builtin.bool(_staleInfo) ? _staleInfo["count"] : 0);
  }
  let proposedByTaskId = {};
  for (const pb of schedule) {
    if (((((pb && !pb.is_fixed) && !pb.is_committed) && pb.task_id) && !(pb.task_id in proposedByTaskId))) {
      proposedByTaskId[pb.task_id] = pb;
    }
  }
  function formatProposedLabel(blk) {
    if (!blk) {
      return "";
    }
    let sd = ((_jac.poly.contains(blk, "scheduled_date") && blk["scheduled_date"]) ? blk["scheduled_date"] : "");
    let st = ((_jac.poly.contains(blk, "start_time") && blk["start_time"]) ? blk["start_time"] : "");
    if (!sd) {
      return ("Proposed (this week) " + st);
    }
    let parts = _jac.poly.call(sd, "split", "-");
    if ((parts.length < 3)) {
      return ((("Proposed " + sd) + " ") + st);
    }
    let _months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let m = parseInt(parts[1]);
    let d = parseInt(parts[2]);
    if (((m < 1) || (m > 12))) {
      return ((("Proposed " + sd) + " ") + st);
    }
    return ((((("Proposed " + _months.at((m - 1))) + " ") + String(d)) + " ") + st);
  }
  let acceptedById = {};
  for (const b of scheduleForWeek) {
    if ((((b && !b.is_fixed) && b.is_committed) && b.task_id)) {
      if (!(b.task_id in acceptedById)) {
        acceptedById[b.task_id] = {"task_id": b.task_id, "task_title": (b.task_title ? b.task_title : ""), "mins": 0, "category": (b.category ? b.category : "other")};
      }
      acceptedById[b.task_id]["mins"] = (acceptedById[b.task_id]["mins"] + (b.duration_mins ? b.duration_mins : 0));
    }
  }
  let schAcceptedTasks = _jac.poly.call(Object, "keys", acceptedById).map(tid => {
    return acceptedById[tid];
  });
  schAcceptedTasks = _jac.builtin.sorted(schAcceptedTasks, i => {
  return ((i && i.task_title) ? String(i.task_title).toLowerCase() : "");
});
  let _calEventYs = [];
  for (const _blk of schAllCal) {
    if (((_blk && _blk.start_time) && !((_jac.poly.contains(_blk, "is_all_day") && _blk["is_all_day"]) ? _blk["is_all_day"] : false))) {
      let _hhStr = _jac.poly.call(_blk.start_time, "split", ":");
      let _yTop = ((parseInt(_hhStr[0]) * _hourHeight) + ((parseInt(_hhStr[1]) * _hourHeight) / 60));
      let _dur = (((_blk.duration_mins ? _blk.duration_mins : 0) * _hourHeight) / 60);
      _calEventYs = _calEventYs.concat([{"top": _yTop, "bottom": (_yTop + _dur)}]);
    }
  }
  _calEventYs = _jac.builtin.sorted(_calEventYs, i => {
  return i.top;
});
  let _firstEventTop = ((_calEventYs.length > 0) ? _calEventYs[0].top : 0);
  let _lastEventTop = ((_calEventYs.length > 0) ? _calEventYs.at((_calEventYs.length - 1)).top : 0);
  let _placedYs = [];
  for (const _pb of schAllCal) {
    let _pbIsFixed = ((_jac.poly.contains(_pb, "is_fixed") && _pb["is_fixed"]) ? _pb["is_fixed"] : false);
    let _pbAllDay = ((_jac.poly.contains(_pb, "is_all_day") && _pb["is_all_day"]) ? _pb["is_all_day"] : false);
    if ((((_pb && _pb.start_time) && !_pbIsFixed) && !_pbAllDay)) {
      let _pbStr = _jac.poly.call(_pb.start_time, "split", ":");
      _placedYs = _placedYs.concat([((parseInt(_pbStr[0]) * _hourHeight) + ((parseInt(_pbStr[1]) * _hourHeight) / 60))]);
    }
  }
  let _firstPlacedTop = (-1);
  for (const _py of _placedYs) {
    if (((_firstPlacedTop < 0) || (_py < _firstPlacedTop))) {
      _firstPlacedTop = _py;
    }
  }
  let _now = Reflect.construct(Date, []);
  let _nowTop = ((_now.getHours() + (_now.getMinutes() / 60)) * _hourHeight);
  let _recomputePillsFromEl = el => {
    let _events = (el.__skoochEventYs ? el.__skoochEventYs : []);
    let _scrollTop = el.scrollTop;
    let _clientH = el.clientHeight;
    let _above = 0;
    let _below = 0;
    for (const _ev of _events) {
      if ((_ev.top < _scrollTop)) {
        _above = (_above + 1);
      }
      if ((_ev.bottom > (_scrollTop + _clientH))) {
        _below = (_below + 1);
      }
    }
    let _topPill = document.getElementById("cal-scroll-edge-top");
    let _botPill = document.getElementById("cal-scroll-edge-bottom");
    if (_topPill) {
      if ((_above > 0)) {
        _topPill.textContent = (("\u2191 " + String(_above)) + ((_above === 1) ? " event above" : " events above"));
        _topPill.style.display = "block";
      } else {
        _topPill.style.display = "none";
      }
    }
    if (_botPill) {
      if ((_below > 0)) {
        _botPill.textContent = (("\u2193 " + String(_below)) + ((_below === 1) ? " event below" : " events below"));
        _botPill.style.display = "block";
      } else {
        _botPill.style.display = "none";
      }
    }
  };
  let _attachScrollListener = el => {
    if (!el) {
      return;
    }
    el.__skoochEventYs = _calEventYs;
    el.__skoochFirstEventTop = _firstEventTop;
    el.__skoochLastEventTop = _lastEventTop;
    el.__skoochFirstPlacedTop = _firstPlacedTop;
    if (!el.__skoochScrollAttached) {
      el.__skoochScrollAttached = true;
      let _ticking = {"v": false};
      el.addEventListener("scroll", () => {
        if (_ticking["v"]) {
          return;
        }
        _ticking["v"] = true;
        requestAnimationFrame(() => {
          _recomputePillsFromEl(el);
          _ticking["v"] = false;
        });
      });
      let _initialTop = (7 * _hourHeight);
      if (schDevScenarioActive) {
        _initialTop = ((_firstEventTop > 30) ? (_firstEventTop - 30) : 0);
      } else if (_isCurrentWeek) {
        let _candidate = (_nowTop - Math.floor((el.clientHeight / 3)));
        _initialTop = ((_candidate > 0) ? _candidate : 0);
      }
      el.scrollTop = _initialTop;
    }
    if (((window.__skoochScrollToFirstBlock && (el.__skoochFirstPlacedTop !== undefined)) && (el.__skoochFirstPlacedTop >= 0))) {
      window.__skoochScrollToFirstBlock = false;
      let _target = (el.__skoochFirstPlacedTop - 30);
      el.scrollTop = ((_target > 0) ? _target : 0);
    }
    _recomputePillsFromEl(el);
  };
  let _DROP_SNAP_MINS = 15;
  let _clearDropHighlights = () => {
    for (const _di of [0, 1, 2, 3, 4, 5, 6]) {
      let _node = document.getElementById(("cal-drop-hl-" + String(_di)));
      if (_node) {
        _node.style.display = "none";
      }
    }
  };
  let _updateDropHighlight = (e, dayIdx) => {
    let _tid = e.dataTransfer.getData("text/plain");
    if (!_tid) {
      _tid = (window.__skoochSchDragTaskId ? window.__skoochSchDragTaskId : "");
    }
    if (!_tid) {
      return;
    }
    let _rect = e.currentTarget.getBoundingClientRect();
    let _y = (e.clientY - _rect.top);
    let _cursorMins = dropYToSlotMins(_y, _hourHeight, _DROP_SNAP_MINS);
    let _day = (dayIdx + 1);
    let _tasks = getStoreTasks();
    let _r = computeMovePlacement(_tid, _day, _cursorMins, _weekIsoDays, _tasks, schedule, fixedBlocks);
    let _node = document.getElementById(("cal-drop-hl-" + String(dayIdx)));
    if (!_node) {
      return;
    }
    let _ok = _r["ok"];
    let _blk = _r["block"];
    let _resolvedMins = _cursorMins;
    let _durMins = 60;
    if ((_ok && _blk)) {
      let _hm = String(_blk.start_time).split(":");
      if ((_hm.length >= 2)) {
        _resolvedMins = ((parseInt(_hm[0]) * 60) + parseInt(_hm[1]));
      }
      _durMins = (_blk.duration_mins ? _blk.duration_mins : 60);
    }
    let _state = classifyDropOutcome(_ok, _cursorMins, _resolvedMins);
    let _cls = "cal-drop-highlight";
    if ((_state === "shoved")) {
      _cls = "cal-drop-highlight cal-drop-highlight-shoved";
    } else if ((_state === "blocked")) {
      _cls = "cal-drop-highlight cal-drop-highlight-blocked";
    }
    for (const _di of [0, 1, 2, 3, 4, 5, 6]) {
      if ((_di !== dayIdx)) {
        let _other = document.getElementById(("cal-drop-hl-" + String(_di)));
        if (_other) {
          _other.style.display = "none";
        }
      }
    }
    _node.className = _cls;
    _node.style.top = (String(((_resolvedMins * _hourHeight) / 60)) + "px");
    _node.style.height = (String(((_durMins * _hourHeight) / 60)) + "px");
    _node.style.display = "block";
    let _label = "";
    if ((_state === "shoved")) {
      _label = "\u2193 next free slot";
    } else if ((_state === "blocked")) {
      _label = "No free slot";
    }
    _node.textContent = _label;
  };
  let _rsnGroups = groupPlacementReasons(((schReasoningTarget && schReasoningTarget.reasons) ? schReasoningTarget.reasons : []));
  let _gcalActive = (((gcalStatus.connected && gcalStatus.sync_enabled) && !schDevScenarioActive) ? true : false);
  let _syncAgo = formatSyncAgo(gcalStatus.last_sync_at, Date.now());
  let _syncState = gcalSyncLabelState(gcalStatus, gcalSyncing, Date.now());
  let _attachSyncClock = el => {
    if (!el) {
      return;
    }
    try {
      if (window.__skoochSyncClockOn) {
        return;
      }
      window.__skoochSyncClockOn = true;
    } catch (__jac_e) {
      if (true) {
        let _ec = __jac_e;
        return;
      } else {
        throw __jac_e;
      }
    }
    try {
      window.setInterval(() => {
        try {
          setStoreGcalClock(((getStoreGcalClock() || 0) + 1));
        } catch (__jac_e) {
          if (true) {
            let _eb = __jac_e;
          } else {
            throw __jac_e;
          }
        }
      }, 30000);
    } catch (__jac_e) {
      if (true) {
        let _ei = __jac_e;
      } else {
        throw __jac_e;
      }
    }
  };
  let _syncSlot = null;
  if (_gcalActive) {
    let _syncInner = null;
    if ((_syncState === "syncing")) {
      _syncInner = __jacJsx("span", {"style": {"display": "inline-flex", "alignItems": "center", "gap": "0.3rem"}}, [__jacJsx("span", {"className": "gcal-sync-spinner"}, []), "Syncing\u2026"]);
    } else if ((_syncState === "error")) {
      _syncInner = __jacJsx("span", {"style": {"display": "inline-flex", "alignItems": "center", "gap": "0.35rem"}, "title": "Last Google Calendar sync failed \u2014 often an expired connection. Click to retry, or reconnect in Profile."}, [__jacJsx("span", {"className": "sch-sync-glyph sch-sync-error"}, ["\u26a0"]), "Sync failed \u2014 retry"]);
    } else if ((_syncState === "synced")) {
      _syncInner = __jacJsx("span", {"style": {"display": "inline-flex", "alignItems": "center", "gap": "0.35rem"}}, [__jacJsx("span", {"className": "sch-sync-glyph"}, ["\u27f3"]), ("Synced " + _syncAgo)]);
    } else {
      _syncInner = __jacJsx("span", {"style": {"display": "inline-flex", "alignItems": "center", "gap": "0.35rem"}}, [__jacJsx("span", {"className": "sch-sync-glyph"}, ["\u27f3"]), "Sync now"]);
    }
    _syncSlot = __jacJsx("button", {"className": "sch-sync-btn", "disabled": gcalSyncing, "ref": _attachSyncClock, "title": "Auto-syncs every 15 min · click to sync now", "onClick": () => {
      onSyncNowGcal();
    }}, [_syncInner]);
  }
  return __jacJsx("div", {"className": (schDevScenarioActive ? "scheduler-page sandbox-active" : "scheduler-page")}, [((!isAdmin && schDevScenarioActive) ? __jacJsx("div", {"className": "sandbox-banner"}, [__jacJsx("span", {"className": "sandbox-banner-icon"}, ["\ud83e\uddea"]), __jacJsx("span", {"className": "sandbox-banner-text"}, ["Welcome to the sandbox -- tell skooch how busy your week is below, then hit Optimize Schedule to see skooch in action."]), __jacJsx("button", {"className": "btn btn-sm btn-primary sandbox-banner-exit", "onClick": () => {
    exitSandbox();
  }}, ["Exit Sandbox"])]) : null), __jacJsx("div", {"className": "scheduler-body"}, [__jacJsx("div", {"className": ((coachMarkStep === 3) ? "sch-panel sch-panel-mid coach-spotlight coach-spotlight-static" : "sch-panel sch-panel-mid")}, [__jacJsx("div", {"className": "sch-section"}, [__jacJsx("div", {"style": {"display": "grid", "gridTemplateColumns": "1fr 1fr 1fr", "gap": "0.5rem", "marginBottom": "0.75rem"}}, [__jacJsx("button", {"className": ((schSidebarMode !== "create_task") ? "btn btn-sm btn-primary" : "btn btn-sm btn-secondary"), "onClick": () => {
    onStateChange("schSidebarMode", "create_task");
  }, "style": {"width": "100%"}}, ["Create task"]), __jacJsx("button", {"className": ((schSidebarMode !== "create_event") ? "btn btn-sm btn-primary" : "btn btn-sm btn-secondary"), "onClick": () => {
    onStateChange("schSidebarMode", "create_event");
  }, "style": {"width": "100%"}}, ["Create event"]), __jacJsx("button", {"className": ((schSidebarMode !== "create_constraint") ? "btn btn-sm btn-primary" : "btn btn-sm btn-secondary"), "onClick": () => {
    onStateChange("schSidebarMode", "create_constraint");
  }, "style": {"width": "100%"}}, ["Add constraint"])]), ((schDevScenarioActive && !isAdmin) ? __jacJsx("div", {"className": "sandbox-task-blurb", "style": {"fontSize": "0.72rem", "color": "var(--text-muted)", "padding": "0.4rem 0.5rem", "background": "rgba(99, 102, 241, 0.06)", "borderRadius": "4px", "marginBottom": "0.4rem", "lineHeight": "1.4"}}, ["These are sample tasks. The optimizer will place them on your calendar based on your preferences."]) : null), ((schSidebarMode === "lot") ? __jacJsx("div", {}, [__jacJsx("div", {"style": {"display": "flex", "alignItems": "center", "justifyContent": "space-between", "marginTop": "0.35rem"}}, [__jacJsx("div", {"style": {"fontSize": "0.72rem", "fontWeight": "700"}}, [(("Unscheduled tasks (" + String(schTasksSidebarCount())) + ")")]), ((_jac.poly.call(Object, "keys", proposedByTaskId).length > 0) ? __jacJsx("button", {"className": "btn btn-sm btn-primary", "style": {"fontSize": "0.65rem", "padding": "0.2rem 0.5rem"}, "onClick": () => {
    acceptAllPlacements();
  }}, [(("Accept all (" + String(_jac.poly.call(Object, "keys", proposedByTaskId).length)) + ")")]) : null)]), __jacJsx("div", {"className": "sch-item-list"}, [orderedSchTasks().map(st => __jacJsx("div", {"key": ("pk-t-" + st.id), "className": "sch-item", "style": {"alignItems": "flex-start"}, "draggable": true, "onDragStart": e => {
    e.dataTransfer.setData("text/plain", st.id);
    e.dataTransfer.effectAllowed = "move";
  }}, [__jacJsx("span", {"className": "category-dot", "style": {"background": schCatColor(st.category), "width": "8px", "height": "8px"}}, []), __jacJsx("div", {"className": "sch-item-info"}, [__jacJsx("div", {"className": "sch-item-title"}, [st.title]), __jacJsx("div", {"className": "sch-item-meta"}, [taskCategoryLabel(st), " | ", st.duration_mins, "m | P:", st.priority, (st.deadline ? (" | " + st.deadline) : "")]), (proposedByTaskId[st.id] ? __jacJsx("div", {"className": "sch-item-meta", "style": {"color": "var(--accent)", "fontStyle": "italic", "marginTop": "0.15rem"}}, [formatProposedLabel(proposedByTaskId[st.id])]) : null)]), (proposedByTaskId[st.id] ? __jacJsx("button", {"className": "sch-item-accept", "title": "Accept proposed placement", "style": {"background": "transparent", "border": "none", "color": "#2ECC71", "cursor": "pointer", "fontSize": "1rem", "padding": "0 0.25rem"}, "onClick": () => {
    acceptScheduledTask(st.id);
  }}, [String.fromCharCode(10003)]) : null), __jacJsx("button", {"className": "sch-item-remove", "onClick": () => {
    removeSchTask(st.id);
  }}, ["x"])])), ((orderedSchTasks().length === 0) ? __jacJsx("div", {"className": "sch-item-meta", "style": {"padding": "0.35rem 0"}}, ["No unscheduled tasks."]) : null)]), __jacJsx("div", {}, [__jacJsx("div", {"style": {"fontSize": "0.72rem", "fontWeight": "700", "marginTop": "0.65rem"}}, [(("Scheduled tasks (" + String(schAcceptedTasks.length)) + ")")]), __jacJsx("div", {"className": "sch-item-list"}, [schAcceptedTasks.map(sct => __jacJsx("div", {"key": ("pk-a-" + String(sct.task_id)), "className": "sch-item"}, [__jacJsx("span", {"className": "category-dot", "style": {"background": schCatColor(sct.category), "width": "8px", "height": "8px"}}, []), __jacJsx("div", {"className": "sch-item-info"}, [__jacJsx("div", {"className": "sch-item-title", "data-clarity-mask": "True"}, [sct.task_title]), __jacJsx("div", {"className": "sch-item-meta"}, [sct.mins, "m scheduled"])]), __jacJsx("button", {"className": "sch-item-remove", "onClick": () => {
    rejectScheduledTask(sct.task_id);
  }}, ["x"])])), ((schAcceptedTasks.length === 0) ? __jacJsx("div", {"className": "sch-item-meta", "style": {"padding": "0.35rem 0"}}, ["No scheduled tasks."]) : null)])]), __jacJsx("div", {"style": {"fontSize": "0.72rem", "fontWeight": "700", "marginTop": "0.65rem"}}, [(("Fixed events (" + String(schFixedEventRows.length)) + ")")]), __jacJsx("div", {"className": "sch-item-list"}, [schFixedEventRows.map(sev => __jacJsx("div", {"key": ("pk-e-" + sev.id), "className": "sch-item"}, [__jacJsx("div", {"className": "sch-item-info"}, [__jacJsx("div", {"className": "sch-item-title"}, [sev.title]), __jacJsx("div", {"className": "sch-item-meta"}, [sev.dayLabel, " ", sev.start_time, "-", sev.end_time])]), __jacJsx("button", {"className": "sch-item-remove", "onClick": () => {
    removeSchEvent(sev.id);
  }}, ["x"])])), ((schFixedEventRows.length === 0) ? __jacJsx("div", {"className": "sch-item-meta", "style": {"padding": "0.35rem 0"}}, ["No fixed events."]) : null)]), __jacJsx("div", {"style": {"fontSize": "0.72rem", "fontWeight": "700", "marginTop": "0.65rem"}}, [(("Constraints (" + String(schConstraints.length)) + ")")]), __jacJsx("div", {"className": "sch-item-list"}, [schConstraints.map(sc => __jacJsx("div", {"key": ("pk-c-" + sc.id), "className": "sch-item"}, [__jacJsx("div", {"className": "sch-item-info"}, [__jacJsx("div", {"className": "sch-item-title"}, [sc.label])]), __jacJsx("button", {"className": "sch-item-remove", "onClick": () => {
    removeSchConstraint(sc.id);
  }}, ["x"])])), ((schConstraints.length === 0) ? __jacJsx("div", {"className": "sch-item-meta", "style": {"padding": "0.35rem 0"}}, ["No constraints."]) : null)])]) : null), ((schSidebarMode === "create_task") ? __jacJsx("div", {}, [__jacJsx("div", {"className": "sch-section-title"}, ["Create task"]), __jacJsx("div", {"className": "sch-form"}, [__jacJsx("input", {"className": "input", "type": "text", "value": schTaskName, "onChange": e => {
    onFormChange("schTaskName", e.target.value);
  }, "placeholder": "Task name"}, []), __jacJsx("select", {"className": "select", "style": ((schFormError && schFormError.includes("category")) ? {"border": "1.5px solid #E74C3C"} : {}), "value": schTaskCat, "onChange": e => {
    onFormChange("schTaskCat", e.target.value);
  }}, [__jacJsx("option", {"value": ""}, ["Pick category…"]), __jacJsx("option", {"value": "fitness"}, ["Fitness"]), __jacJsx("option", {"value": "social"}, ["Social"]), __jacJsx("option", {"value": "creative"}, ["Creative"]), __jacJsx("option", {"value": "learning"}, ["Learning"]), __jacJsx("option", {"value": "writing"}, ["Writing"]), __jacJsx("option", {"value": "coding"}, ["Coding"]), __jacJsx("option", {"value": "admin"}, ["Admin"]), __jacJsx("option", {"value": "other"}, ["Other"])]), __jacJsx("div", {"className": "sch-form-row", "style": {"gap": "0.35rem"}}, [__jacJsx("span", {"style": {"fontSize": "0.75rem", "minWidth": "55px"}}, ["Duration"]), __jacJsx("input", {"className": "input", "type": "number", "min": "0", "step": "1", "value": schTaskDurH, "onChange": e => {
    onFormChange("schTaskDurH", parseInt(e.target.value));
  }, "style": {"width": "70px"}}, []), __jacJsx("span", {"style": {"fontSize": "0.75rem"}}, ["h"]), __jacJsx("input", {"className": "input", "type": "number", "min": "0", "max": "59", "step": "5", "value": schTaskDurM, "onChange": e => {
    onFormChange("schTaskDurM", parseInt(e.target.value));
  }, "style": {"width": "70px"}}, []), __jacJsx("span", {"style": {"fontSize": "0.75rem"}}, ["m"])]), __jacJsx("div", {"className": "sch-form-row"}, [__jacJsx("span", {"style": {"fontSize": "0.75rem", "minWidth": "55px"}}, ["Priority"]), __jacJsx("input", {"className": "range-slider", "type": "range", "min": "1", "max": "10", "value": schTaskPri, "onChange": e => {
    onFormChange("schTaskPri", parseInt(e.target.value));
  }}, []), __jacJsx("span", {"style": {"fontSize": "0.75rem", "minWidth": "16px"}}, [schTaskPri])]), __jacJsx("div", {"className": "sch-toggle"}, [__jacJsx("button", {"className": ("sch-toggle-btn" + (!schTaskIsRecurring ? " sch-toggle-btn-active" : "")), "onClick": () => {
    onFormChange("schTaskIsRecurring", false);
  }}, ["Single"]), __jacJsx("button", {"className": ("sch-toggle-btn" + (schTaskIsRecurring ? " sch-toggle-btn-active" : "")), "onClick": () => {
    onFormChange("schTaskIsRecurring", true);
  }}, ["Recurring"])]), (!schTaskIsRecurring ? __jacJsx("div", {"className": "sch-form-row"}, [__jacJsx("span", {"style": {"fontSize": "0.75rem", "minWidth": "55px"}}, ["Deadline"]), __jacJsx("input", {"className": "input", "type": "date", "value": schTaskDL, "onChange": e => {
    onFormChange("schTaskDL", e.target.value);
  }, "style": {"flex": "1"}}, [])]) : __jacJsx("div", {}, [__jacJsx("div", {"className": "sch-form-row", "style": {"gap": "0.35rem"}}, [__jacJsx("span", {"style": {"fontSize": "0.75rem", "minWidth": "55px"}}, ["Every"]), __jacJsx("input", {"className": "input", "type": "number", "min": "1", "step": "1", "value": schTaskRecurrenceInterval, "onChange": e => {
    onFormChange("schTaskRecurrenceInterval", parseInt(e.target.value));
  }, "style": {"width": "70px"}}, []), __jacJsx("select", {"className": "select", "value": schTaskRecurrenceUnit, "onChange": e => {
    onFormChange("schTaskRecurrenceUnit", e.target.value);
  }, "style": {"flex": "1"}}, [__jacJsx("option", {"value": "week"}, ["Week"]), __jacJsx("option", {"value": "month"}, ["Month"]), __jacJsx("option", {"value": "year"}, ["Year"])])]), __jacJsx("div", {"className": "day-picker", "style": {"marginTop": "0.6rem"}}, [[1, 2, 3, 4, 5, 6, 7].map(di => __jacJsx("button", {"key": ("rt-" + String(di)), "className": ((schTaskRecurrenceWeekday === di) ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schTaskRecurrenceWeekday", di);
  }}, [["M", "T", "W", "Th", "F", "Sa", "Su"].at((di - 1))]))])])), __jacJsx("div", {"className": "sch-form-actions"}, [__jacJsx("button", {"className": "btn btn-sm btn-primary", "onClick": () => {
    addSchTask();
  }}, ["Add Task"]), __jacJsx("button", {"className": "btn btn-sm btn-secondary", "onClick": () => {
    onStateChange("schSidebarMode", "lot");
    onStateChange("schFormError", "");
  }}, ["Cancel"])]), (schFormError ? __jacJsx("div", {"className": "sch-inline-error"}, [schFormError]) : null)])]) : null), ((schSidebarMode === "create_event") ? __jacJsx("div", {}, [__jacJsx("div", {"className": "sch-section-title"}, ["Create fixed event"]), __jacJsx("div", {"className": "sch-form"}, [__jacJsx("input", {"className": "input", "type": "text", "value": schEvName, "onChange": e => {
    onFormChange("schEvName", e.target.value);
  }, "placeholder": "Event name"}, []), __jacJsx("select", {"className": "select", "value": schEvCat, "onChange": e => {
    onFormChange("schEvCat", e.target.value);
  }}, [__jacJsx("option", {"value": ""}, ["Pick category…"]), __jacJsx("option", {"value": "fitness"}, ["Fitness"]), __jacJsx("option", {"value": "creative"}, ["Creative"]), __jacJsx("option", {"value": "learning"}, ["Learning"]), __jacJsx("option", {"value": "coding"}, ["Coding"]), __jacJsx("option", {"value": "admin"}, ["Admin"]), __jacJsx("option", {"value": "other"}, ["Other"])]), __jacJsx("input", {"className": "input", "type": "text", "value": schEvLoc, "onChange": e => {
    onFormChange("schEvLoc", e.target.value);
  }, "placeholder": "Location (optional)"}, []), __jacJsx("label", {"style": {"display": "flex", "alignItems": "center", "gap": "0.4rem", "fontSize": "0.8rem", "cursor": "pointer", "marginBottom": "0.1rem"}}, [__jacJsx("input", {"type": "checkbox", "checked": schEvIsAllDay, "onChange": e => {
    onFormChange("schEvIsAllDay", e.target.checked);
  }}, []), "All-day event"]), (!schEvIsAllDay ? __jacJsx("div", {"className": "time-row"}, [__jacJsx("input", {"className": "input", "type": "time", "value": schEvStart, "onChange": e => {
    onFormChange("schEvStart", e.target.value);
  }}, []), __jacJsx("span", {"className": "time-separator"}, ["to"]), __jacJsx("input", {"className": "input", "type": "time", "value": schEvEnd, "onChange": e => {
    onFormChange("schEvEnd", e.target.value);
  }}, [])]) : null), __jacJsx("div", {"className": "sch-toggle"}, [__jacJsx("button", {"className": ("sch-toggle-btn" + (!schEvIsRecurring ? " sch-toggle-btn-active" : "")), "onClick": () => {
    onFormChange("schEvIsRecurring", false);
  }}, ["Single"]), __jacJsx("button", {"className": ("sch-toggle-btn" + (schEvIsRecurring ? " sch-toggle-btn-active" : "")), "onClick": () => {
    onFormChange("schEvIsRecurring", true);
  }}, ["Recurring"])]), (schEvIsRecurring ? __jacJsx("div", {}, [__jacJsx("div", {"className": "sch-form-row", "style": {"gap": "0.35rem"}}, [__jacJsx("span", {"style": {"fontSize": "0.75rem", "minWidth": "55px"}}, ["Every"]), __jacJsx("input", {"className": "input", "type": "number", "min": "1", "step": "1", "value": schEvRecurrenceInterval, "onChange": e => {
    onFormChange("schEvRecurrenceInterval", parseInt(e.target.value));
  }, "style": {"width": "70px"}}, []), __jacJsx("select", {"className": "select", "value": schEvRecurrenceUnit, "onChange": e => {
    onFormChange("schEvRecurrenceUnit", e.target.value);
  }, "style": {"flex": "1"}}, [__jacJsx("option", {"value": "week"}, ["Week"]), __jacJsx("option", {"value": "month"}, ["Month"]), __jacJsx("option", {"value": "year"}, ["Year"])])]), ((schEvRecurrenceUnit !== "week") ? __jacJsx("div", {"className": "sch-disclaimer"}, ["Monthly/Yearly aren’t implemented yet (will behave as weekly for now)."]) : null), __jacJsx("div", {"className": "day-picker", "style": {"marginTop": "0.6rem"}}, [__jacJsx("button", {"className": (schEvMon ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schEvMon", !schEvMon);
  }}, ["M"]), __jacJsx("button", {"className": (schEvTue ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schEvTue", !schEvTue);
  }}, ["T"]), __jacJsx("button", {"className": (schEvWed ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schEvWed", !schEvWed);
  }}, ["W"]), __jacJsx("button", {"className": (schEvThu ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schEvThu", !schEvThu);
  }}, ["Th"]), __jacJsx("button", {"className": (schEvFri ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schEvFri", !schEvFri);
  }}, ["F"]), __jacJsx("button", {"className": (schEvSat ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schEvSat", !schEvSat);
  }}, ["Sa"]), __jacJsx("button", {"className": (schEvSun ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schEvSun", !schEvSun);
  }}, ["Su"])])]) : __jacJsx("div", {"className": "sch-form-row"}, [__jacJsx("span", {"style": {"fontSize": "0.75rem", "minWidth": "55px"}}, ["Date"]), __jacJsx("input", {"className": "input", "type": "date", "value": schEvDate, "onChange": e => {
    onFormChange("schEvDate", e.target.value);
  }, "style": {"flex": "1"}}, [])])), __jacJsx("div", {"className": "sch-form-actions"}, [__jacJsx("button", {"className": "btn btn-sm btn-primary", "onClick": () => {
    addSchEvent();
  }}, ["Add Event"]), __jacJsx("button", {"className": "btn btn-sm btn-secondary", "onClick": () => {
    onStateChange("schSidebarMode", "lot");
    onStateChange("schFormError", "");
  }}, ["Cancel"])]), (schFormError ? __jacJsx("div", {"className": "sch-inline-error"}, [schFormError]) : null)])]) : null), ((schSidebarMode === "create_constraint") ? __jacJsx("div", {}, [__jacJsx("div", {"className": "sch-section-title"}, ["Add constraint"]), __jacJsx("div", {"className": "sch-form"}, [__jacJsx("select", {"className": "select", "value": schConType, "onChange": e => {
    onFormChange("schConType", e.target.value);
  }}, [__jacJsx("option", {"value": "block_time"}, ["Block time range"]), __jacJsx("option", {"value": "no_category_day"}, ["No category on day"]), __jacJsx("option", {"value": "max_daily_hours"}, ["Max daily hours"])]), ((schConType === "block_time") ? __jacJsx("div", {}, [__jacJsx("div", {"className": "time-row"}, [__jacJsx("input", {"className": "input", "type": "time", "value": schConStart, "onChange": e => {
    onFormChange("schConStart", e.target.value);
  }}, []), __jacJsx("span", {"className": "time-separator"}, ["to"]), __jacJsx("input", {"className": "input", "type": "time", "value": schConEnd, "onChange": e => {
    onFormChange("schConEnd", e.target.value);
  }}, [])]), __jacJsx("div", {"className": "day-picker", "style": {"marginTop": "0.3rem"}}, [__jacJsx("button", {"className": (schConMon ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConMon", !schConMon);
  }}, ["M"]), __jacJsx("button", {"className": (schConTue ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConTue", !schConTue);
  }}, ["T"]), __jacJsx("button", {"className": (schConWed ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConWed", !schConWed);
  }}, ["W"]), __jacJsx("button", {"className": (schConThu ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConThu", !schConThu);
  }}, ["Th"]), __jacJsx("button", {"className": (schConFri ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConFri", !schConFri);
  }}, ["F"]), __jacJsx("button", {"className": (schConSat ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConSat", !schConSat);
  }}, ["Sa"]), __jacJsx("button", {"className": (schConSun ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConSun", !schConSun);
  }}, ["Su"])])]) : ((schConType === "no_category_day") ? __jacJsx("div", {}, [__jacJsx("select", {"className": "select", "value": schConCat, "onChange": e => {
    onFormChange("schConCat", e.target.value);
  }}, [__jacJsx("option", {"value": "fitness"}, ["Fitness"]), __jacJsx("option", {"value": "creative"}, ["Creative"]), __jacJsx("option", {"value": "learning"}, ["Learning"]), __jacJsx("option", {"value": "writing"}, ["Writing"]), __jacJsx("option", {"value": "coding"}, ["Coding"]), __jacJsx("option", {"value": "admin"}, ["Admin"])]), __jacJsx("div", {"className": "day-picker", "style": {"marginTop": "0.3rem"}}, [__jacJsx("button", {"className": (schConMon ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConMon", !schConMon);
  }}, ["M"]), __jacJsx("button", {"className": (schConTue ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConTue", !schConTue);
  }}, ["T"]), __jacJsx("button", {"className": (schConWed ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConWed", !schConWed);
  }}, ["W"]), __jacJsx("button", {"className": (schConThu ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConThu", !schConThu);
  }}, ["Th"]), __jacJsx("button", {"className": (schConFri ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConFri", !schConFri);
  }}, ["F"]), __jacJsx("button", {"className": (schConSat ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConSat", !schConSat);
  }}, ["Sa"]), __jacJsx("button", {"className": (schConSun ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onFormChange("schConSun", !schConSun);
  }}, ["Su"])])]) : __jacJsx("div", {"className": "sch-form-row"}, [__jacJsx("span", {"style": {"fontSize": "0.75rem"}}, ["Max hours:"]), __jacJsx("input", {"className": "input", "type": "number", "min": "1", "max": "16", "value": schConMax, "onChange": e => {
    onFormChange("schConMax", parseInt(e.target.value));
  }, "style": {"width": "60px"}}, [])]))), __jacJsx("div", {"className": "sch-form-actions"}, [__jacJsx("button", {"className": "btn btn-sm btn-primary", "onClick": () => {
    addSchConstraint();
  }}, ["Add Constraint"]), __jacJsx("button", {"className": "btn btn-sm btn-secondary", "onClick": () => {
    onStateChange("schSidebarMode", "lot");
    onStateChange("schFormError", "");
  }}, ["Cancel"])]), (schFormError ? __jacJsx("div", {"className": "sch-inline-error"}, [schFormError]) : null)])]) : null)])]), (isMobileViewport ? __jacJsx("div", {"className": (schDevScenarioActive ? "mobile-sched mobile-sched-sandbox" : "mobile-sched")}, [__jacJsx(MobileViewSwitcher, {}, []), __jacJsx(MobileUnscheduled, {"callbacks": {"schCatColor": schCatColor, "onOptimize": (schDevScenarioActive ? null : () => {
    if (schDirty) {
      runOptimize();
    }
  })}}, []), ((mobileSchedView === "day") ? __jacJsx(MobileDayView, {"schAllCal": schAllCal, "weekInfo": weekInfo, "sandboxActive": schDevScenarioActive, "callbacks": {"openSchPopup": openSchPopup, "schCatColor": schCatColor, "mergeContiguousChunks": mergeContiguousChunks}}, []) : null), ((mobileSchedView === "week") ? __jacJsx(MobileWeekAgenda, {"schAllCal": schAllCal, "weekInfo": weekInfo, "sandboxActive": schDevScenarioActive, "callbacks": {"openSchPopup": openSchPopup, "schCatColor": schCatColor, "mergeContiguousChunks": mergeContiguousChunks, "onPrevWeek": onPrevWeek, "onNextWeek": onNextWeek}}, []) : null), ((mobileSchedView === "month") ? __jacJsx(MobileMonthView, {"schAllCal": schAllCal, "weekIsoDays": _weekIsoDays, "schCatColor": schCatColor, "sandboxActive": schDevScenarioActive}, []) : null), (schDevScenarioActive ? __jacJsx("div", {"className": "mobile-sandbox-bar"}, [(mobileSandboxToast ? __jacJsx("div", {"className": "mobile-sandbox-toast", "key": mobileSandboxToast}, [mobileSandboxToast]) : null), __jacJsx("div", {"className": "mobile-sandbox-row"}, [__jacJsx("div", {"className": "mobile-sandbox-hint"}, [(schLog ? schLog : "Pick a sample week, then Optimize to watch skooch plan it.")]), __jacJsx("button", {"className": "mobile-sandbox-exit", "onClick": () => {
    exitSandbox();
  }}, ["Exit demo"])]), __jacJsx("div", {"className": "mobile-sandbox-sev"}, [__jacJsx("button", {"className": "mobile-sev-card", "onClick": () => {
    runRandomize();
    _showSbToast("\ud83d\udccb Light week loaded. Hit Optimize to plan it.");
  }}, [__jacJsx("span", {"className": "mobile-sev-emoji"}, ["\ud83d\ude0a"]), __jacJsx("span", {"className": "mobile-sev-label"}, ["Light"])]), __jacJsx("button", {"className": "mobile-sev-card", "onClick": () => {
    runStressTest("mild");
    _showSbToast("\ud83d\udccb Busy week loaded. Hit Optimize to plan it.");
  }}, [__jacJsx("span", {"className": "mobile-sev-emoji"}, ["\ud83d\ude10"]), __jacJsx("span", {"className": "mobile-sev-label"}, ["Busy"])]), __jacJsx("button", {"className": "mobile-sev-card", "onClick": () => {
    runStressTest("impossible");
    _showSbToast("\ud83d\udccb Finals week loaded. Hit Optimize to plan it.");
  }}, [__jacJsx("span", {"className": "mobile-sev-emoji"}, ["\ud83d\ude24"]), __jacJsx("span", {"className": "mobile-sev-label"}, ["Finals"])])]), __jacJsx("button", {"className": "btn btn-primary mobile-sandbox-optimize", "disabled": !schDirty, "onClick": () => {
    if (schDirty) {
      runOptimize();
      _showSbToast("\u2713 Scheduled! Your week is planned. Want changes? Open Chat and ask Skooch.");
    }
  }}, [(schDirty ? "Optimize Schedule" : "Schedule's up to date")]), ((schOptimized && (onContinueAsGuest !== null)) ? __jacJsx("button", {"className": "btn mobile-sandbox-claim", "onClick": () => {
    onContinueAsGuest();
  }}, ["Try with your own schedule \u2192"]) : null)]) : null)]) : __jacJsx("div", {"className": "sch-calendar"}, [SchedulerWeekNav(_weekLabel, onPrevWeek, onNextWeek, schZoom, applySchZoom, _syncSlot), ((_staleCount > 0) ? __jacJsx("div", {"className": "sch-stale-banner", "style": {"display": "flex", "alignItems": "center", "justifyContent": "space-between", "gap": "0.75rem", "padding": "0.5rem 0.75rem", "background": "rgba(201, 138, 31, 0.10)", "borderBottom": "1px solid var(--border)", "fontSize": "0.78rem"}}, [__jacJsx("span", {"style": {"color": "var(--text)"}}, [__jacJsx("strong", {}, [String(_staleCount)]), ((_staleCount === 1) ? " task isn't on this week." : " tasks aren't on this week.")]), __jacJsx("button", {"className": "btn btn-sm btn-primary", "style": {"flexShrink": "0", "whiteSpace": "nowrap"}, "onClick": () => {
    replanStalePlacements();
  }}, ["Re-plan this week"])]) : null), __jacJsx("div", {"style": {"display": "flex", "borderBottom": "1px solid var(--border)", "background": "var(--bg-card)"}}, [__jacJsx("div", {"style": {"width": "48px", "flexShrink": "0"}}, []), __jacJsx("div", {"style": {"flex": "1", "display": "grid", "gridTemplateColumns": "repeat(7, 1fr)"}}, [[0, 1, 2, 3, 4, 5, 6].map(dhi => __jacJsx("div", {"key": ("dh-" + String(dhi)), "className": ("calendar-day-header calendar-day-header-click" + ((_isCurrentWeek && (dhi === _todayIdx)) ? " calendar-day-today" : "")), "style": {"background": ((_isCurrentWeek && (dhi === _todayIdx)) ? "var(--accent-bg, rgba(74, 144, 217, 0.08))" : "transparent")}, "onClick": () => {
    viewDayInDashboard((dhi + 1));
  }, "title": (("View " + _jac.poly.getitem(_dayNames, dhi)) + " in Dashboard")}, [__jacJsx("span", {}, [_jac.poly.getitem(_dayNames, dhi)]), __jacJsx("span", {"style": {"fontSize": "0.65rem", "color": "var(--text-muted)"}}, [_jac.poly.getitem(_dayDates, dhi)])]))])]), __jacJsx("div", {"className": "calendar-allday-strip", "style": {"display": "flex", "borderBottom": "1px solid var(--border)", "background": "var(--bg-card)"}}, [__jacJsx("div", {"className": "calendar-allday-label", "style": {"width": "48px", "flexShrink": "0", "borderRight": "1px solid var(--border)", "fontSize": "0.6rem", "color": "var(--text-muted)", "padding": "4px 5px", "display": "flex", "alignItems": "center", "justifyContent": "flex-end"}}, ["all-day"]), __jacJsx("div", {"style": {"flex": "1", "display": "grid", "gridTemplateColumns": "repeat(7, 1fr)", "minHeight": "48px"}}, [[0, 1, 2, 3, 4, 5, 6].map(dayIdx => __jacJsx("div", {"key": ("adday-" + String(dayIdx)), "className": "calendar-allday-cell", "style": {"borderRight": "1px solid var(--border-light)", "padding": "2px 4px", "minHeight": "48px", "display": "flex", "flexDirection": "column", "gap": "4px"}}, [schAllCal.filter(b => {
    let isoDay = ((dayIdx < _weekIsoDays.length) ? _jac.poly.getitem(_weekIsoDays, dayIdx) : "");
    let sd = ((_jac.poly.contains(b, "scheduled_date") && b["scheduled_date"]) ? b["scheduled_date"] : "");
    let isAllDay = ((_jac.poly.contains(b, "is_all_day") && b["is_all_day"]) ? b["is_all_day"] : false);
    if (!isAllDay) {
      return false;
    }
    return (((sd && isoDay) && (sd === isoDay)) || (!sd && (b.day === (dayIdx + 1))));
  }).map(blk => __jacJsx("div", {"key": ("ad-" + String(blk.id)), "className": "cal-block-allday", "style": {"background": schCatColor(blk.category)}, "onClick": () => {
    openSchPopup(blk);
  }, "title": blk.task_title}, [blk.task_title]))]))])]), __jacJsx("div", {"style": {"position": "relative"}}, [__jacJsx("div", {"id": "cal-scroll-container", "ref": _attachScrollListener, "style": {"overflow": "auto", "maxHeight": "calc(100vh - 240px)", "position": "relative"}}, [__jacJsx("div", {"className": "calendar-grid", "style": {"display": "flex", "minHeight": (String((24 * _hourHeight)) + "px"), "position": "relative"}}, [__jacJsx("div", {"style": {"width": "48px", "flexShrink": "0", "borderRight": "1px solid var(--border)"}}, [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23].map(hh => __jacJsx("div", {"key": ("st-" + String(hh)), "className": (((hh < 7) || (hh >= 23)) ? "hour-label non-work-hours" : "hour-label"), "style": {"height": (String(_hourHeight) + "px"), "display": "flex", "alignItems": "flex-start", "justifyContent": "flex-end", "padding": "2px 5px", "fontSize": "0.65rem", "color": "var(--text-muted)"}}, [(((hh < 12) && (hh > 0)) ? (String(hh) + "am") : ((hh > 12) ? (String((hh - 12)) + "pm") : ((hh === 12) ? "12pm" : "12am")))]))]), __jacJsx("div", {"style": {"flex": "1", "display": "grid", "gridTemplateColumns": "repeat(7, 1fr)", "position": "relative", "backgroundImage": (("repeating-linear-gradient(to bottom, var(--border-light) 0px, var(--border-light) 1px, transparent 1px, transparent " + String(_hourHeight)) + "px)"), "backgroundSize": (("100% " + String(_hourHeight)) + "px")}}, [[0, 1, 2, 3, 4, 5, 6].map(dayIdx => __jacJsx("div", {"key": ("sch-day-" + String(dayIdx)), "style": {"position": "relative", "borderRight": "1px solid var(--border-light)"}, "onDragOver": e => {
    e.preventDefault();
    try {
      _updateDropHighlight(e, dayIdx);
    } catch (__jac_e) {
      if (true) {
        let _ehl = __jac_e;
      } else {
        throw __jac_e;
      }
    }
  }, "onDragLeave": e => {
    let _hn = document.getElementById(("cal-drop-hl-" + String(dayIdx)));
    if (_hn) {
      _hn.style.display = "none";
    }
  }, "onDrop": e => {
    e.preventDefault();
    try {
      _clearDropHighlights();
    } catch (__jac_e) {
      if (true) {
        let _ecl = __jac_e;
      } else {
        throw __jac_e;
      }
    }
    let tid = e.dataTransfer.getData("text/plain");
    if (!tid) {
      tid = (window.__skoochSchDragTaskId ? window.__skoochSchDragTaskId : "");
    }
    if (!tid) {
      return;
    }
    let rect = e.currentTarget.getBoundingClientRect();
    let y = (e.clientY - rect.top);
    let startMins = dropYToSlotMins(y, _hourHeight, 15);
    placeSchTask(tid, (dayIdx + 1), startMins);
  }}, [__jacJsx("div", {"className": "non-work-hours", "style": {"position": "absolute", "left": "0", "right": "0", "top": "0", "height": (String((7 * _hourHeight)) + "px"), "pointerEvents": "none"}}, []), __jacJsx("div", {"className": "non-work-hours", "style": {"position": "absolute", "left": "0", "right": "0", "top": (String((23 * _hourHeight)) + "px"), "height": (String(_hourHeight) + "px"), "pointerEvents": "none"}}, []), __jacJsx("div", {"id": ("cal-drop-hl-" + String(dayIdx)), "className": "cal-drop-highlight", "style": {"display": "none"}}, []), mergeContiguousChunks(schAllCal.filter(b => {
    let isoDay = ((dayIdx < _weekIsoDays.length) ? _jac.poly.getitem(_weekIsoDays, dayIdx) : "");
    let sd = ((_jac.poly.contains(b, "scheduled_date") && b["scheduled_date"]) ? b["scheduled_date"] : "");
    let isAllDay = ((_jac.poly.contains(b, "is_all_day") && b["is_all_day"]) ? b["is_all_day"] : false);
    if (isAllDay) {
      return false;
    }
    return (((sd && isoDay) && (sd === isoDay)) || (!sd && (b.day === (dayIdx + 1))));
  })).map(blk => __jacJsx("div", {"key": blk.id, "className": (blk.is_fixed ? "cal-block cal-block-fixed" : (((blk.is_committed !== undefined) && blk.is_committed) ? "cal-block cal-block-committed" : "cal-block cal-block-ghost")), "draggable": !blk.is_fixed, "style": {"top": (String(((parseInt(_jac.poly.call(blk.start_time, "split", ":")[0]) * _hourHeight) + ((parseInt(_jac.poly.call(blk.start_time, "split", ":")[1]) * _hourHeight) / 60))) + "px"), "height": (String(((blk.duration_mins * _hourHeight) / 60)) + "px"), "background": schCatColor(blk.category), "cursor": (blk.is_fixed ? "default" : "grab")}, "onDragStart": e => {
    window.__skoochSchBlockDragged = true;
    window.__skoochSchDragTaskId = blk.task_id;
    e.dataTransfer.setData("text/plain", blk.task_id);
    e.dataTransfer.effectAllowed = "move";
  }, "onDragEnd": e => {
    window.setTimeout(() => {
      window.__skoochSchBlockDragged = false;
    }, 0);
    window.__skoochSchDragTaskId = "";
    try {
      _clearDropHighlights();
    } catch (__jac_e) {
      if (true) {
        let _ede = __jac_e;
      } else {
        throw __jac_e;
      }
    }
  }, "onClick": () => {
    if (window.__skoochSchBlockDragged) {
      window.__skoochSchBlockDragged = false;
      return;
    }
    openSchPopup(blk);
  }}, [__jacJsx("div", {"className": "cal-block-title"}, [blk.task_title]), __jacJsx("div", {"className": "cal-block-time"}, [blk.start_time, "-", blk.end_time]), (!blk.is_fixed ? __jacJsx("div", {"className": "confidence-badge", "title": "Placement confidence \u2014 how well this slot fits your preferences (energy, focus peak, deadline). Click the block for the full reasoning."}, [(String(blk.confidence) + "% fit")]) : __jacJsx("div", {"className": "cal-block-fixed-badge"}, ["FIXED"]))]))]))]), (_isCurrentWeek ? __jacJsx("div", {"id": "cal-now-line", "className": "cal-now-line", "style": {"top": (String(_nowTop) + "px")}}, []) : null)])]), __jacJsx("div", {"id": "cal-scroll-edge-top", "className": "cal-scroll-edge-pill cal-scroll-edge-top", "style": {"display": "none"}, "onClick": () => {
    let _c = document.getElementById("cal-scroll-container");
    if (_c) {
      _c.scrollTo({"top": (_firstEventTop - 30), "behavior": "smooth"});
    }
  }}, []), __jacJsx("div", {"id": "cal-scroll-edge-bottom", "className": "cal-scroll-edge-pill cal-scroll-edge-bottom", "style": {"display": "none"}, "onClick": () => {
    let _c = document.getElementById("cal-scroll-container");
    if (_c) {
      _c.scrollTo({"top": (_lastEventTop - 30), "behavior": "smooth"});
    }
  }}, [])])]))]), __jacJsx("div", {"className": "sch-bottom", "style": (schDevScenarioActive ? {"flexWrap": "wrap"} : {})}, [__jacJsx("button", {"disabled": (!schDirty || (!profileComplete && !schDevScenarioActive)), "title": ((!profileComplete && !schDevScenarioActive) ? "Finish your profile to enable Optimize" : ""), "className": (schDirty ? ("btn btn-optimize btn-optimize-dirty" + ((coachMarkStep === 3) ? " coach-spotlight coach-spotlight-static" : "")) : "btn btn-optimize btn-optimize-clean"), "onClick": () => {
    if ((schDirty && (profileComplete || schDevScenarioActive))) {
      runOptimize();
    }
  }}, [((!profileComplete && !schDevScenarioActive) ? "Finish profile to optimize" : (schDirty ? "Optimize Schedule" : "Schedule's up to date"))]), (((!profileComplete && !schDevScenarioActive) && (onFinishProfile !== null)) ? __jacJsx("button", {"className": "btn btn-sm btn-primary sch-finish-profile-cta", "onClick": () => {
    if ((onFinishProfile !== null)) {
      onFinishProfile();
    }
  }, "title": "Take the quick onboarding survey to enable Optimize", "style": {"marginLeft": "0.5rem"}}, ["Finish profile \u2192"]) : null), (schOptimized ? __jacJsx("button", {"className": "btn btn-sm btn-secondary", "onClick": () => {
    onStateChange("schReportOpen", !schReportOpen);
    if (schReportOpen) {
      onStateChange("schReasoningTarget", {});
    }
  }, "style": {"marginLeft": "0.5rem"}}, [(schReportOpen ? "Hide reasoning" : "Show reasoning")]) : null), ((isAdmin && devMode) ? __jacJsx("div", {"className": "dev-toolbar"}, [__jacJsx("span", {"className": "dev-badge"}, ["DEV"]), __jacJsx("button", {"className": "btn-dev", "onClick": () => {
    runRandomize();
  }}, ["Randomize"]), __jacJsx("button", {"className": "btn-dev", "onClick": () => {
    runStressTest("mild");
  }}, ["Stress: Mild"]), __jacJsx("button", {"className": "btn-dev", "onClick": () => {
    runStressTest("heavy");
  }}, ["Stress: Heavy"]), __jacJsx("button", {"className": "btn-dev", "onClick": () => {
    runStressTest("impossible");
  }}, ["Stress: Impossible"]), __jacJsx("span", {"style": {"borderLeft": "1px solid var(--border)", "margin": "0 4px"}}, []), __jacJsx("span", {"style": {"fontSize": "0.65rem", "color": "var(--text-muted)", "marginRight": "2px"}}, ["Day:"]), [1, 2, 3, 4, 5, 6, 7].map(di => __jacJsx("button", {"key": ("dv-" + String(di)), "className": ((selectedDay === di) ? "btn-dev btn-dev-active" : "btn-dev"), "onClick": () => {
    viewDayInDashboard(di);
  }, "style": {"minWidth": "32px"}}, [["M", "T", "W", "T", "F", "S", "S"].at((di - 1))])), __jacJsx("button", {"className": "btn-dev", "onClick": () => {
    viewDayInDashboard(0);
  }, "style": {"fontSize": "0.6rem"}}, ["Today"]), __jacJsx("span", {"style": {"borderLeft": "1px solid var(--border)", "margin": "0 4px"}}, []), __jacJsx("button", {"className": "btn-dev", "onClick": () => {
    onStateChange("devMode", false);
  }}, ["Hide Dev"])]) : ((isAdmin && !devMode) ? __jacJsx("button", {"className": "btn btn-sm btn-secondary", "onClick": () => {
    onStateChange("devMode", true);
  }, "style": {"fontSize": "0.65rem"}}, ["DEV"]) : null)), ((!isAdmin && schDevScenarioActive) ? __jacJsx("div", {"className": ((coachMarkStep === 2) ? "sandbox-toolbar coach-spotlight" : "sandbox-toolbar")}, [__jacJsx("span", {"className": "sandbox-badge"}, ["SAMPLE"]), __jacJsx("div", {"className": "sandbox-severity-picker"}, [__jacJsx("button", {"className": "severity-card severity-easy", "onClick": () => {
    runRandomize();
  }}, [__jacJsx("span", {"className": "severity-emoji"}, ["\ud83d\ude0a"]), __jacJsx("span", {"className": "severity-label"}, ["Light week"])]), __jacJsx("button", {"className": "severity-card severity-busy", "onClick": () => {
    runStressTest("mild");
  }}, [__jacJsx("span", {"className": "severity-emoji"}, ["\ud83d\ude10"]), __jacJsx("span", {"className": "severity-label"}, ["Busy week"])]), __jacJsx("button", {"className": "severity-card severity-finals", "onClick": () => {
    runStressTest("impossible");
  }}, [__jacJsx("span", {"className": "severity-emoji"}, ["\ud83d\ude24"]), __jacJsx("span", {"className": "severity-label"}, ["Finals mode"])])]), __jacJsx("button", {"className": "btn btn-sm btn-secondary", "onClick": () => {
    runRandomize();
  }, "style": {"fontSize": "0.7rem"}}, ["New sample week"]), __jacJsx("button", {"className": "btn btn-sm btn-primary", "onClick": () => {
    exitSandbox();
  }, "style": {"fontSize": "0.7rem"}}, ["Exit Sandbox"]), ((schOptimized && (onContinueAsGuest !== null)) ? __jacJsx("button", {"className": "btn btn-sm sandbox-guest-cta", "onClick": () => {
    onContinueAsGuest();
  }, "style": {"fontSize": "0.7rem"}}, ["Try with your own schedule \u2192"]) : null)]) : null), __jacJsx("div", {"className": "sch-log", "style": (schDevScenarioActive ? {"flexBasis": "100%", "order": (-1)} : {})}, [schLog]), ((isAdmin && devMode) ? __jacJsx("div", {"className": "sch-log", "style": {"marginTop": "0.2rem", "fontSize": "0.62rem", "color": "var(--text-muted)"}}, [((((((("DBG cal: schedule=" + String(schedule.length)) + " scheduleForWeek=") + String(scheduleForWeek.length)) + " fixedForWeek=") + String(fixedForWeek.length)) + " weekIso0=") + ((_weekIsoDays.length > 0) ? _weekIsoDays[0] : ""))]) : null)]), (visibleSuggestions.length ? __jacJsx("div", {"className": "sch-suggestions"}, [__jacJsx("span", {"style": {"fontSize": "0.72rem", "fontWeight": "600", "color": "var(--text-muted)"}}, ["Suggestions:"]), visibleSuggestions.map((sg, si) => {
    let lines = schSuggestionLines(sg, schConstraints, schPrefBuf);
    let sugLine1 = lines["line1"];
    let sugLine2 = lines["line2"];
    let k = (((("sug-" + String(si)) + "-") + sg.action) + (sg.task_id ? sg.task_id : ""));
    return __jacJsx("div", {"key": k, "className": "sch-suggestion", "onClick": () => {
      applySuggestion(sg);
    }}, [__jacJsx("div", {"className": "sch-suggestion-primary"}, [sugLine1]), ((sugLine2.length > 0) ? __jacJsx("div", {"className": "sch-suggestion-subline"}, [sugLine2]) : null)]);
  })]) : null), ((schReportOpen && (schOptimized || (schReasoningTarget && schReasoningTarget.id))) ? __jacJsx("div", {"className": "sch-popup-overlay", "style": {"zIndex": "1000"}, "onClick": () => {
    onStateChange("schReportOpen", false);
    onStateChange("schReasoningTarget", {});
  }}, []) : null), ((schReportOpen && (schOptimized || (schReasoningTarget && schReasoningTarget.id))) ? __jacJsx("div", {"className": "sch-popup", "style": {"maxWidth": "880px", "width": "min(880px, 95vw)", "maxHeight": "85vh", "overflow": "hidden", "display": "flex", "flexDirection": "column", "zIndex": "1001"}, "onClick": e => {
    if ((e.target === e.currentTarget)) {
      onStateChange("schReportOpen", false);
      onStateChange("schReasoningTarget", {});
    }
  }}, [__jacJsx("div", {"style": {"display": "flex", "justifyContent": "space-between", "alignItems": "center", "marginBottom": "0.5rem"}}, [__jacJsx("span", {"className": "sch-popup-title"}, ["Reasoning"]), __jacJsx("button", {"className": "btn btn-sm btn-secondary", "onClick": () => {
    onStateChange("schReportOpen", false);
    onStateChange("schReasoningTarget", {});
  }}, ["Close"])]), ((schDevScenarioActive && !isAdmin) ? __jacJsx("div", {"style": {"fontSize": "0.7rem", "padding": "0.5rem 0.65rem", "marginBottom": "0.5rem", "borderRadius": "6px", "background": "var(--accent-light)", "border": "1px solid var(--accent)", "color": "var(--text-primary)"}}, [__jacJsx("strong", {}, ["Sandbox reasoning."]), " ", " These placements were generated from just 2 quick-prefs answers (focus peak + work-life balance). The real Skooch builds a comprehensive profile across categories, deadlines, energy curve, deep-work flow, and your real fixed events."]) : null), __jacJsx("div", {"style": {"fontSize": "0.7rem", "color": "var(--text-muted)", "marginBottom": "0.5rem"}}, [((((((("Parameters used: Focus peak " + schPrefPeak) + ", Block length ") + String(schPrefBlock)) + " min, Buffer ") + String(schPrefBuf)) + " min, Strategy ") + schPrefStrat)]), __jacJsx("div", {"style": {"flex": "1", "overflowY": "auto", "display": "grid", "gridTemplateColumns": "1fr 1fr", "gap": "0.5rem"}}, [__jacJsx("div", {"style": {"borderRight": "1px solid var(--border)", "paddingRight": "0.5rem"}}, [__jacJsx("div", {"style": {"fontWeight": "600", "fontSize": "0.75rem", "marginBottom": "0.35rem"}}, ["Placements"]), schedule.map(blk => __jacJsx("div", {"key": blk.id, "style": {"fontSize": "0.75rem", "padding": "0.35rem", "borderRadius": "6px", "cursor": "pointer", "borderLeft": ("4px solid " + schCatColor(blk.category)), "background": ((schReasoningTarget && (schReasoningTarget.id === blk.id)) ? "var(--accent-light)" : "transparent")}, "onClick": () => {
    onStateChange("schReasoningTarget", blk);
  }}, [__jacJsx("div", {"style": {"fontWeight": "600"}}, [blk.task_title]), __jacJsx("div", {"style": {"color": "var(--text-muted)", "fontSize": "0.7rem"}}, [["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].at((blk.day - 1)), " ", blk.start_time, " · ", blk.category])])), schOverflow.map(ov => __jacJsx("div", {"key": ("ov-" + ov.id), "style": {"fontSize": "0.75rem", "padding": "0.35rem", "borderRadius": "6px", "cursor": "pointer", "borderLeft": ("4px solid " + schCatColor(ov.category)), "background": ((schReasoningTarget && (schReasoningTarget.id === ov.id)) ? "var(--accent-light)" : "transparent")}, "onClick": () => {
    onStateChange("schReasoningTarget", ov);
  }}, [__jacJsx("div", {"style": {"fontWeight": "600"}}, [ov.title]), __jacJsx("div", {"style": {"color": "var(--text-muted)", "fontSize": "0.7rem"}}, ["Not placed"])])), (((schedule.length === 0) && (schOverflow.length === 0)) ? __jacJsx("div", {"style": {"fontSize": "0.75rem", "color": "var(--text-muted)", "padding": "0.35rem"}}, ["No optimized tasks available yet."]) : null)]), __jacJsx("div", {"style": {"fontSize": "0.75rem"}}, [((schReasoningTarget && ((schReasoningTarget.id || schReasoningTarget.task_title) || schReasoningTarget.title)) ? __jacJsx("div", {}, [__jacJsx("div", {"style": {"fontWeight": "600", "marginBottom": "0.4rem"}}, [(schReasoningTarget.task_title ? schReasoningTarget.task_title : schReasoningTarget.title)]), __jacJsx("div", {"style": {"fontSize": "0.7rem", "color": "var(--text-muted)", "marginBottom": "0.5rem"}}, [(((schReasoningTarget.start_time ? schReasoningTarget.start_time : "") + (schReasoningTarget.end_time ? (" - " + schReasoningTarget.end_time) : "")) + (schReasoningTarget.category ? (" \u00b7 " + schReasoningTarget.category) : ""))]), ((schReasoningTarget.reasons && (schReasoningTarget.reasons.length > 0)) ? __jacJsx("div", {"style": {"marginTop": "0.5rem"}}, [(_rsnGroups.verdict ? __jacJsx("div", {"style": {"marginBottom": "0.45rem", "padding": "0.35rem 0.5rem", "background": "var(--accent-light)", "borderLeft": "3px solid var(--accent)", "borderRadius": "4px", "fontSize": "0.75rem", "fontWeight": "600"}}, [("Why here: " + _rsnGroups.verdict)]) : null), __jacJsx("div", {"style": {"marginBottom": "0.35rem", "fontSize": "0.75rem"}}, [("Your peak hours: " + ((schPrefPeak === "morning") ? "8am\u201312pm" : ((schPrefPeak === "midday") ? "12pm\u20134pm" : ((schPrefPeak === "afternoon") ? "4pm\u20138pm" : "6pm\u201310pm"))))]), ((_rsnGroups.peak.length > 0) ? __jacJsx("div", {"style": {"fontWeight": "600", "fontSize": "0.7rem", "color": "var(--text-muted)", "marginBottom": "0.2rem"}}, ["Peak hours"]) : null), _rsnGroups.peak.map(rsn => __jacJsx("div", {"key": ("peak-" + rsn), "style": {"marginBottom": "0.2rem", "paddingLeft": "0.5rem", "borderLeft": "2px solid var(--accent)", "fontSize": "0.75rem"}}, [rsn])), ((_rsnGroups.energy.length > 0) ? __jacJsx("div", {"style": {"fontWeight": "600", "fontSize": "0.7rem", "color": "var(--text-muted)", "marginTop": "0.35rem", "marginBottom": "0.2rem"}}, ["Energy"]) : null), _rsnGroups.energy.map(rsn => __jacJsx("div", {"key": ("en-" + rsn), "style": {"marginBottom": "0.2rem", "paddingLeft": "0.5rem", "borderLeft": "2px solid #F39C12", "fontSize": "0.75rem"}}, [rsn])), ((_rsnGroups.deadline.length > 0) ? __jacJsx("div", {"style": {"fontWeight": "600", "fontSize": "0.7rem", "color": "var(--text-muted)", "marginTop": "0.35rem", "marginBottom": "0.2rem"}}, ["Deadline"]) : null), _rsnGroups.deadline.map(rsn => __jacJsx("div", {"key": ("dl-" + rsn), "style": {"marginBottom": "0.2rem", "paddingLeft": "0.5rem", "borderLeft": "2px solid #E74C3C", "fontSize": "0.75rem"}}, [rsn])), ((_rsnGroups.balance.length > 0) ? __jacJsx("div", {"style": {"fontWeight": "600", "fontSize": "0.7rem", "color": "var(--text-muted)", "marginTop": "0.35rem", "marginBottom": "0.2rem"}}, ["Day balance"]) : null), _rsnGroups.balance.map(rsn => __jacJsx("div", {"key": ("bal-" + rsn), "style": {"marginBottom": "0.2rem", "paddingLeft": "0.5rem", "borderLeft": "2px solid #2ECC71", "fontSize": "0.75rem"}}, [rsn])), ((_rsnGroups.flow.length > 0) ? __jacJsx("div", {"style": {"fontWeight": "600", "fontSize": "0.7rem", "color": "var(--text-muted)", "marginTop": "0.35rem", "marginBottom": "0.2rem"}}, ["Flow"]) : null), _rsnGroups.flow.map(rsn => __jacJsx("div", {"key": ("fl-" + rsn), "style": {"marginBottom": "0.2rem", "paddingLeft": "0.5rem", "borderLeft": "2px solid #9B59B6", "fontSize": "0.75rem"}}, [rsn])), ((_rsnGroups.other.length > 0) ? __jacJsx("div", {"style": {"fontWeight": "600", "fontSize": "0.7rem", "color": "var(--text-muted)", "marginTop": "0.35rem", "marginBottom": "0.2rem"}}, ["Also considered"]) : null), _rsnGroups.other.map(rsn => __jacJsx("div", {"key": ("ot-" + rsn), "style": {"marginBottom": "0.2rem", "paddingLeft": "0.5rem", "borderLeft": "2px solid var(--border)", "fontSize": "0.75rem"}}, [rsn]))]) : __jacJsx("div", {"style": {"marginTop": "0.5rem"}}, [(((schReasoningTarget.reason_details && (schReasoningTarget.reason_details.length > 0)) ? schReasoningTarget.reason_details : (schReasoningTarget.reason_short ? [schReasoningTarget.reason_short] : []))).map(rsn => __jacJsx("div", {"key": ("rg-" + rsn), "style": {"marginBottom": "0.25rem", "paddingLeft": "0.5rem", "borderLeft": "2px solid var(--border)", "fontSize": "0.75rem"}}, [rsn]))]))]) : __jacJsx("div", {"style": {"color": "var(--text-muted)", "fontSize": "0.8rem"}}, [(((schedule.length === 0) && (schOverflow.length === 0)) ? "No task reasoning available. Add tasks and run Optimize." : "Click a placement to see why it was scheduled there.")]))])])]) : null), (schPopupOpen ? __jacJsx("div", {}, [__jacJsx("div", {"className": "sch-popup-overlay", "onClick": () => {
    closeSchPopup();
  }}, []), __jacJsx("div", {"className": "sch-popup"}, [__jacJsx("div", {"className": "sch-popup-title"}, [__jacJsx("span", {"className": "category-dot", "style": {"background": schCatColor(schEditCat), "width": "8px", "height": "8px", "display": "inline-block", "marginRight": "0.4rem"}}, []), schPopupBlock.task_title]), __jacJsx("div", {"className": "sch-popup-edit-row"}, [__jacJsx("span", {"className": "sch-popup-label"}, ["Title"]), __jacJsx("input", {"className": "input", "type": "text", "value": schEditTitle, "onChange": e => {
    onStateChange("schEditTitle", e.target.value);
  }}, [])]), __jacJsx("div", {"className": "sch-popup-edit-row"}, [__jacJsx("span", {"className": "sch-popup-label"}, ["Category"]), __jacJsx("select", {"className": "select", "value": schEditCat, "onChange": e => {
    onStateChange("schEditCat", e.target.value);
  }}, [__jacJsx("option", {"value": "coding"}, ["Coding"]), __jacJsx("option", {"value": "writing"}, ["Writing"]), __jacJsx("option", {"value": "learning"}, ["Learning"]), __jacJsx("option", {"value": "creative"}, ["Creative"]), __jacJsx("option", {"value": "admin"}, ["Admin"]), __jacJsx("option", {"value": "social"}, ["Social"]), __jacJsx("option", {"value": "fitness"}, ["Fitness"]), __jacJsx("option", {"value": "other"}, ["Other"])])]), __jacJsx("div", {"className": "sch-popup-edit-row"}, [__jacJsx("span", {"className": "sch-popup-label"}, ["Location"]), __jacJsx("input", {"className": "input", "type": "text", "value": schEditLoc, "onChange": e => {
    onStateChange("schEditLoc", e.target.value);
  }, "placeholder": "Optional"}, [])]), ((schPopupIsExternal && !schPopupIsExternalOneoff) ? __jacJsx("div", {}, [__jacJsx("div", {"className": "sch-popup-row"}, [__jacJsx("span", {"className": "sch-popup-label"}, ["Time"]), __jacJsx("span", {"className": "sch-popup-value"}, [schPopupBlock.start_time, " - ", schPopupBlock.end_time])]), (schPopupBlock.scheduled_date ? __jacJsx("div", {"className": "sch-popup-row"}, [__jacJsx("span", {"className": "sch-popup-label"}, ["Date"]), __jacJsx("span", {"className": "sch-popup-value"}, [schPopupBlock.scheduled_date])]) : null), __jacJsx("div", {"className": "sch-popup-source-note"}, ["Synced from Google Calendar — change its time there and it will sync in."])]) : ((schPopupBlock.is_fixed || schPopupIsExternalOneoff) ? __jacJsx("div", {}, [__jacJsx("div", {"className": "sch-popup-edit-row"}, [__jacJsx("span", {"className": "sch-popup-label"}, [(schPopupIsExternalOneoff ? "Start" : "Time")]), __jacJsx("input", {"className": "input", "type": "time", "value": schEditStart, "onChange": e => {
    onStateChange("schEditStart", e.target.value);
  }}, []), __jacJsx("span", {"className": "time-separator"}, ["to"]), __jacJsx("input", {"className": "input", "type": "time", "value": schEditEnd, "onChange": e => {
    onStateChange("schEditEnd", e.target.value);
  }}, [])]), (schPopupIsRecurringFixed ? __jacJsx("div", {"className": "sch-popup-edit-row"}, [__jacJsx("span", {"className": "sch-popup-label"}, ["Days"]), __jacJsx("div", {"className": "day-picker", "style": {"margin": "0"}}, [[1, 2, 3, 4, 5, 6, 7].map(di => __jacJsx("button", {"key": ("pd-" + String(di)), "className": (schEditDays.includes(di) ? "day-btn day-btn-active" : "day-btn"), "onClick": () => {
    onStateChange("schEditDays", (schEditDays.includes(di) ? schEditDays.filter(dd => {
      return (dd !== di);
    }) : schEditDays.concat([di])));
  }}, [["M", "T", "W", "Th", "F", "Sa", "Su"].at((di - 1))]))])]) : __jacJsx("div", {"className": "sch-popup-edit-row"}, [__jacJsx("span", {"className": "sch-popup-label"}, ["Date"]), __jacJsx("input", {"className": "input", "type": "date", "value": schEditDate, "onChange": e => {
    onStateChange("schEditDate", e.target.value);
  }}, [])])), (schPopupIsExternalOneoff ? __jacJsx("div", {"className": "sch-popup-source-note"}, ["From Google Calendar — changes save back to your Google Calendar."]) : null)]) : __jacJsx("div", {}, [__jacJsx("div", {"className": "sch-popup-edit-row"}, [__jacJsx("span", {"className": "sch-popup-label"}, ["Start"]), __jacJsx("input", {"className": "input", "type": "time", "value": schEditStart, "onChange": e => {
    onStateChange("schEditStart", e.target.value);
  }}, []), __jacJsx("select", {"className": "select", "value": String(schEditDay), "onChange": e => {
    onStateChange("schEditDay", parseInt(e.target.value));
  }}, [__jacJsx("option", {"value": "1"}, ["Mon"]), __jacJsx("option", {"value": "2"}, ["Tue"]), __jacJsx("option", {"value": "3"}, ["Wed"]), __jacJsx("option", {"value": "4"}, ["Thu"]), __jacJsx("option", {"value": "5"}, ["Fri"]), __jacJsx("option", {"value": "6"}, ["Sat"]), __jacJsx("option", {"value": "7"}, ["Sun"])])]), __jacJsx("div", {"className": "sch-popup-edit-row"}, [__jacJsx("span", {"className": "sch-popup-label"}, ["Duration"]), __jacJsx("input", {"className": "input", "type": "number", "min": "15", "step": "5", "value": schEditDur, "onChange": e => {
    onStateChange("schEditDur", parseInt(e.target.value));
  }, "style": {"width": "80px", "flex": "0 0 auto"}}, []), __jacJsx("span", {"style": {"fontSize": "0.75rem", "color": "var(--text-muted)"}}, ["min"])]), __jacJsx("div", {"className": "sch-popup-edit-row"}, [__jacJsx("span", {"className": "sch-popup-label"}, ["Priority"]), __jacJsx("input", {"className": "range-slider", "type": "range", "min": "1", "max": "10", "value": schEditPri, "onChange": e => {
    onStateChange("schEditPri", parseInt(e.target.value));
  }}, []), __jacJsx("span", {"style": {"fontSize": "0.75rem", "minWidth": "16px"}}, [schEditPri])]), __jacJsx("div", {"className": "sch-popup-edit-row"}, [__jacJsx("span", {"className": "sch-popup-label"}, ["Deadline"]), __jacJsx("input", {"className": "input", "type": "date", "value": schEditDL, "onChange": e => {
    onStateChange("schEditDL", e.target.value);
  }}, [])]), __jacJsx("div", {"className": "sch-popup-row"}, [__jacJsx("span", {"className": "sch-popup-label"}, ["Confidence"]), __jacJsx("span", {"className": "sch-popup-value", "style": {"fontWeight": "700", "color": ((schPopupBlock.confidence > 70) ? "var(--accent)" : ((schPopupBlock.confidence > 40) ? "#F0AD4E" : "#E74C3C"))}}, [schPopupBlock.confidence, "%"])]), __jacJsx("div", {"style": {"padding": "0.4rem 0", "borderTop": "1px solid var(--border-light)", "marginTop": "0.3rem"}}, [__jacJsx("div", {"style": {"fontSize": "0.68rem", "fontWeight": "700", "color": "var(--text-muted)", "marginBottom": "0.3rem", "textTransform": "uppercase", "letterSpacing": "0.04em"}}, ["Why this slot?"]), ((schPopupBlock.reasons ? schPopupBlock.reasons : [])).map(rsn => __jacJsx("div", {"key": rsn, "style": {"fontSize": "0.72rem", "color": "var(--text-secondary)", "padding": "0.15rem 0", "paddingLeft": "0.5rem", "borderLeft": "2px solid var(--border-light)"}}, [rsn])), __jacJsx("button", {"className": "sch-popup-reasoning-link", "onClick": () => {
    onStateChange("schReasoningTarget", schPopupBlock);
    onStateChange("schReportOpen", true);
  }}, ["Open full reasoning"])])]))), (schFormError ? __jacJsx("div", {"className": "sch-inline-error"}, [schFormError]) : null), __jacJsx("div", {"className": "sch-popup-actions"}, [__jacJsx("button", {"className": "btn btn-primary btn-sm", "disabled": !schPopupDirty, "onClick": () => {
    if (schPopupBlock.is_fixed) {
      saveSchPopupFixedEdits();
    } else {
      saveSchPopupEdits();
    }
  }}, [((schPopupSaveState === "saved") ? "Saved." : ((schPopupSaveState === "saving") ? "Saving\u2026" : "Save"))]), __jacJsx("button", {"className": "btn btn-secondary btn-sm", "onClick": () => {
    closeSchPopup();
  }}, ["Close"]), ((!schPopupBlock.is_fixed && ((schPopupBlock.is_committed === undefined) || !schPopupBlock.is_committed)) ? __jacJsx("button", {"className": "btn btn-success btn-sm", "onClick": () => {
    acceptScheduledTask(schPopupBlock.task_id);
    closeSchPopup();
  }}, ["Accept"]) : (!schPopupBlock.is_fixed ? __jacJsx("button", {"className": "btn btn-success btn-sm", "disabled": true, "style": {"opacity": 0.65, "cursor": "not-allowed"}}, ["Accept"]) : null)), (!schPopupBlock.is_fixed ? __jacJsx("button", {"className": "btn btn-danger btn-sm", "onClick": () => {
    rejectScheduledTask(schPopupBlock.task_id);
    closeSchPopup();
  }}, ["Reject"]) : null), (!schPopupBlock.is_fixed ? __jacJsx("button", {"className": "btn btn-danger btn-sm", "onClick": () => {
    deleteTaskAndPlacements(schPopupBlock.task_id);
    closeSchPopup();
  }}, ["Delete"]) : __jacJsx("button", {"className": "btn btn-danger btn-sm", "onClick": () => {
    let _confirmDelEvent = true;
    let _delMsg = (schPopupIsRecurringFixed ? "Delete this event and all its repeats?" : "Delete this event?");
    try {
      _confirmDelEvent = window.confirm(_delMsg);
    } catch (__jac_e) {
      if (true) {
        let _delErr = __jac_e;
      } else {
        throw __jac_e;
      }
    }
    if (_confirmDelEvent) {
      removeSchPopupBlock();
      closeSchPopup();
    }
  }}, ["Delete"]))])])]) : null)]);
}
export {SchedulerView};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:SchedulerView": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=scheduler_view.js.map
